import gql from "graphql-tag";
import * as VueApolloComposable from "@vue/apollo-composable";
import * as VueCompositionApi from "vue";
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: any;
  /** The `DateTimeOffset` scalar type represents a date, time and offset from UTC. `DateTimeOffset` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTimeOffset: any;
  Guid: any;
};

export type AddNotificationEmailInputType = {
  emailAddress?: Maybe<Scalars["String"]>;
};

export type AddProfileRoleInputType = {
  profileId?: Maybe<Scalars["ID"]>;
  roleId?: Maybe<Scalars["ID"]>;
};

export type AddRoleAssigneeInputType = {
  roleId?: Maybe<Scalars["ID"]>;
  organizationId?: Maybe<Scalars["ID"]>;
  roleName?: Maybe<Scalars["String"]>;
  organizationName?: Maybe<Scalars["String"]>;
  applicationName?: Maybe<Scalars["String"]>;
};

export type AddUserRoleInputType = {
  userId?: Maybe<Scalars["ID"]>;
  roleId?: Maybe<Scalars["ID"]>;
  organizationId?: Maybe<Scalars["ID"]>;
};

export type ApplicationType = {
  applicationId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  emailContacts?: Maybe<Array<Maybe<Scalars["String"]>>>;
  roles?: Maybe<Array<Maybe<RoleType>>>;
  profiles?: Maybe<Array<Maybe<ProfileType>>>;
};

export type AssignUserRoleOnBehalfOfInputfType = {
  userId: Scalars["String"];
  roleId: Scalars["Guid"];
  organizationId: Scalars["Guid"];
};

export type BasicOrganizationType = {
  organizationId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  vat?: Maybe<Scalars["String"]>;
  /** number of users in the organization */
  userCount?: Maybe<Scalars["Int"]>;
};

export type BasicOrganizationsType = {
  count?: Maybe<Scalars["Int"]>;
  items?: Maybe<Array<Maybe<BasicOrganizationType>>>;
};

export type BasicOrganizationsTypeItemsArgs = {
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type BatchRoleAssignmentItem = {
  email?: Maybe<Scalars["String"]>;
  roleName?: Maybe<Scalars["String"]>;
  roleId?: Maybe<Scalars["Guid"]>;
  orgCVR?: Maybe<Scalars["String"]>;
  organizationId?: Maybe<Scalars["Guid"]>;
  organizationName?: Maybe<Scalars["String"]>;
};

export type BatchRoleAssignmentItemResult = {
  email?: Maybe<Scalars["String"]>;
  roleName?: Maybe<Scalars["String"]>;
  roleId?: Maybe<Scalars["Guid"]>;
  orgCVR?: Maybe<Scalars["String"]>;
  organizationId?: Maybe<Scalars["Guid"]>;
  isSuccess?: Maybe<Scalars["Boolean"]>;
  failureReason?: Maybe<Scalars["String"]>;
};

export type BatchRoleAssignmentOption = {
  isSimulation?: Maybe<Scalars["Boolean"]>;
};

export type BatchRoleAssignmentResult = {
  isSimulation?: Maybe<Scalars["Boolean"]>;
  success?: Maybe<Scalars["Boolean"]>;
  errors?: Maybe<Array<Maybe<Scalars["String"]>>>;
  totalAssignments?: Maybe<Scalars["Int"]>;
  totalUsersAssignment?: Maybe<Scalars["Int"]>;
  assignedRoles?: Maybe<Array<Maybe<BatchRoleAssignmentItemResult>>>;
  processedAt?: Maybe<Scalars["DateTime"]>;
  finishedAt?: Maybe<Scalars["DateTime"]>;
};

export type BatchRolesUploadResult = {
  success?: Maybe<Scalars["Boolean"]>;
  errors?: Maybe<Array<Maybe<Scalars["String"]>>>;
  validRoleAssignmentItems?: Maybe<Array<Maybe<BatchRoleAssignmentItem>>>;
};

export type ChangeUserMitIdInputType = {
  mitID?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["ID"]>;
};

export type ChangeUserPasswordInputType = {
  userId?: Maybe<Scalars["ID"]>;
  password?: Maybe<Scalars["String"]>;
};

export type CreateApplicationInputType = {
  name?: Maybe<Scalars["String"]>;
  emailContacts?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CreateOrUpdateNotificationOptionsInputType = {
  onUserChanges?: Maybe<Scalars["Boolean"]>;
  onRoleChanges?: Maybe<Scalars["Boolean"]>;
  onApplicationChanges?: Maybe<Scalars["Boolean"]>;
  onOrganizationChanges?: Maybe<Scalars["Boolean"]>;
  onSystemChanges?: Maybe<Scalars["Boolean"]>;
  onRoleProfileChanges?: Maybe<Scalars["Boolean"]>;
  onUserOnboardingPerApplication?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type CreateOrganizationInputType = {
  name?: Maybe<Scalars["String"]>;
  vat?: Maybe<Scalars["String"]>;
  notifiedOnChange?: Maybe<Scalars["Boolean"]>;
  notifiedOnUserChange?: Maybe<Scalars["Boolean"]>;
  notifiedOnRoleAssignmentChange?: Maybe<Scalars["Boolean"]>;
  assigneeRoles?: Maybe<Array<Maybe<AddRoleAssigneeInputType>>>;
};

export type CreateProfileInputType = {
  applicationId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  levelOfUse?: Maybe<LevelOfUse>;
  roleIds?: Maybe<Array<Maybe<Scalars["Guid"]>>>;
};

export type CreateRoleInputType = {
  applicationId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  attribute?: Maybe<Scalars["String"]>;
  isOnBehalf?: Maybe<Scalars["Boolean"]>;
  assigneeOrganizationIds?: Maybe<Array<Maybe<Scalars["Guid"]>>>;
};

export type CreateUserInputType = {
  email?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  organizationId?: Maybe<Scalars["ID"]>;
  administrator?: Maybe<Scalars["Boolean"]>;
  firstname?: Maybe<Scalars["String"]>;
  lastname?: Maybe<Scalars["String"]>;
  mitID?: Maybe<Scalars["String"]>;
  kombitID?: Maybe<Scalars["String"]>;
  eID?: Maybe<Scalars["String"]>;
  roleIds?: Maybe<Array<Maybe<Scalars["Guid"]>>>;
};

export type DirectoryMutation = {
  createOrganization?: Maybe<OrganizationType>;
  updateOrganization?: Maybe<OrganizationType>;
  deleteOrganization?: Maybe<Scalars["String"]>;
  createUser?: Maybe<UserType>;
  updateUser?: Maybe<UserType>;
  changeUserPassword?: Maybe<Scalars["String"]>;
  /** Resets an enrolled User Catalog TOTP authenticator and deletes the associated Identify user, using the VD user ID. Returns false if skipped or either step fails. */
  resetUserAuthenticatorRegistration: Scalars["Boolean"];
  deleteUser?: Maybe<Scalars["String"]>;
  deleteInactiveUsers?: Maybe<Array<Maybe<UserType>>>;
  addUserRole?: Maybe<Scalars["String"]>;
  removeUserRole?: Maybe<Scalars["String"]>;
  removeRoleApplication?: Maybe<Scalars["String"]>;
  assignUserRoleOnBehalfOf?: Maybe<Scalars["String"]>;
  changeUserMitID?: Maybe<Scalars["String"]>;
  createOnboardingUser?: Maybe<OnboardingUserResultType>;
  migrateUser?: Maybe<UserType>;
  migrateUserToNonEidOrganization?: Maybe<UserType>;
  updateUserLastLogin?: Maybe<Scalars["String"]>;
  doBatchRoleAssignments?: Maybe<BatchRoleAssignmentResult>;
  createApplication?: Maybe<ApplicationType>;
  updateApplication?: Maybe<ApplicationType>;
  deleteApplication?: Maybe<Scalars["String"]>;
  createRole?: Maybe<RoleType>;
  updateRole?: Maybe<RoleType>;
  deleteRole?: Maybe<Scalars["String"]>;
  addRoleAssignee?: Maybe<Scalars["String"]>;
  removeRoleAssignee?: Maybe<Scalars["String"]>;
  createProfile?: Maybe<ProfileType>;
  updateProfile?: Maybe<ProfileType>;
  deleteProfile?: Maybe<Scalars["String"]>;
  addProfileRole?: Maybe<Scalars["String"]>;
  removeProfileRole?: Maybe<Scalars["String"]>;
  updateSetting?: Maybe<SettingType>;
  uploadBatchRoleAssignmentsCsv?: Maybe<BatchRolesUploadResult>;
  addNotificationEmail?: Maybe<NotificationEmailType>;
  deleteNotificationEmail?: Maybe<Scalars["String"]>;
  updateNotificationOptions?: Maybe<Scalars["String"]>;
};

export type DirectoryMutationCreateOrganizationArgs = {
  input: CreateOrganizationInputType;
};

export type DirectoryMutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInputType;
};

export type DirectoryMutationDeleteOrganizationArgs = {
  organizationId: Scalars["ID"];
};

export type DirectoryMutationCreateUserArgs = {
  input: CreateUserInputType;
};

export type DirectoryMutationUpdateUserArgs = {
  input: UpdateUserInputType;
};

export type DirectoryMutationChangeUserPasswordArgs = {
  input: ChangeUserPasswordInputType;
};

export type DirectoryMutationResetUserAuthenticatorRegistrationArgs = {
  userId: Scalars["ID"];
};

export type DirectoryMutationDeleteUserArgs = {
  userId: Scalars["ID"];
};

export type DirectoryMutationAddUserRoleArgs = {
  input: AddUserRoleInputType;
};

export type DirectoryMutationRemoveUserRoleArgs = {
  input: RemoveUserRoleInputType;
};

export type DirectoryMutationRemoveRoleApplicationArgs = {
  input: RemoveRoleApplicationInputType;
};

export type DirectoryMutationAssignUserRoleOnBehalfOfArgs = {
  input: AssignUserRoleOnBehalfOfInputfType;
};

export type DirectoryMutationChangeUserMitIdArgs = {
  input: ChangeUserMitIdInputType;
};

export type DirectoryMutationCreateOnboardingUserArgs = {
  input: CreateUserInputType;
  applicationId: Scalars["ID"];
};

export type DirectoryMutationMigrateUserArgs = {
  userId: Scalars["ID"];
  applicationId: Scalars["ID"];
  mitID?: Maybe<Scalars["String"]>;
  kombitID?: Maybe<Scalars["String"]>;
  eID?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
  orgVat?: Maybe<Scalars["String"]>;
  notifyEmail?: Maybe<Scalars["Boolean"]>;
};

export type DirectoryMutationMigrateUserToNonEidOrganizationArgs = {
  userId: Scalars["ID"];
};

export type DirectoryMutationUpdateUserLastLoginArgs = {
  userId: Scalars["ID"];
};

export type DirectoryMutationDoBatchRoleAssignmentsArgs = {
  input: BatchRoleAssignmentOption;
};

export type DirectoryMutationCreateApplicationArgs = {
  input: CreateApplicationInputType;
};

export type DirectoryMutationUpdateApplicationArgs = {
  input: UpdateApplicationInputType;
};

export type DirectoryMutationDeleteApplicationArgs = {
  applicationId: Scalars["ID"];
};

export type DirectoryMutationCreateRoleArgs = {
  input: CreateRoleInputType;
};

export type DirectoryMutationUpdateRoleArgs = {
  input: UpdateRoleInputType;
};

export type DirectoryMutationDeleteRoleArgs = {
  roleId: Scalars["ID"];
};

export type DirectoryMutationAddRoleAssigneeArgs = {
  input: AddRoleAssigneeInputType;
};

export type DirectoryMutationRemoveRoleAssigneeArgs = {
  roleId: Scalars["ID"];
  organizationId: Scalars["ID"];
};

export type DirectoryMutationCreateProfileArgs = {
  input: CreateProfileInputType;
};

export type DirectoryMutationUpdateProfileArgs = {
  input: UpdateProfileInputType;
};

export type DirectoryMutationDeleteProfileArgs = {
  profileId: Scalars["ID"];
};

export type DirectoryMutationAddProfileRoleArgs = {
  input: AddProfileRoleInputType;
};

export type DirectoryMutationRemoveProfileRoleArgs = {
  input: RemoveProfileRoleInputType;
};

export type DirectoryMutationUpdateSettingArgs = {
  input: UpdateSettingInputType;
};

export type DirectoryMutationUploadBatchRoleAssignmentsCsvArgs = {
  input: UploadCsvInputType;
};

export type DirectoryMutationAddNotificationEmailArgs = {
  input: AddNotificationEmailInputType;
};

export type DirectoryMutationDeleteNotificationEmailArgs = {
  emailId: Scalars["ID"];
};

export type DirectoryMutationUpdateNotificationOptionsArgs = {
  emailId: Scalars["ID"];
  input: CreateOrUpdateNotificationOptionsInputType;
  settingItemType?: Maybe<SettingItemType>;
  activate?: Maybe<Scalars["Boolean"]>;
  applicationName?: Maybe<Scalars["String"]>;
};

export type DirectoryQuery = {
  userCatalogSettings?: Maybe<UserCatalogSettings>;
  userProfile?: Maybe<UserProfileType>;
  getUserMyProfile?: Maybe<UserType>;
  users?: Maybe<UsersType>;
  user?: Maybe<UserType>;
  /** Get users by email */
  usersByEmail?: Maybe<Array<Maybe<UserType>>>;
  userByMitID?: Maybe<UserType>;
  userByKombitID?: Maybe<UserType>;
  userByEID?: Maybe<UserType>;
  usersPagination?: Maybe<PaginationResultUserGraphType>;
  organizations?: Maybe<BasicOrganizationsType>;
  organizationsForRoleAssignee?: Maybe<BasicOrganizationsType>;
  organization?: Maybe<OrganizationType>;
  applications?: Maybe<Array<Maybe<ApplicationType>>>;
  application?: Maybe<ApplicationType>;
  roles?: Maybe<Array<Maybe<RoleType>>>;
  role?: Maybe<RoleType>;
  /** List of role assignees */
  roleAssignees?: Maybe<Array<Maybe<RoleAssigneeType>>>;
  /** List of roles for user */
  rolesForUser?: Maybe<Array<Maybe<RoleAssigneeType>>>;
  profiles?: Maybe<Array<Maybe<ProfileType>>>;
  profilesByLevelOfUse?: Maybe<Array<Maybe<ProfileType>>>;
  profile?: Maybe<ProfileType>;
  setting?: Maybe<SettingType>;
  /** Get the result of the last batch role assignment simulation */
  lastBatchRoleAssignmentSimulation?: Maybe<SettingType>;
  /** Check if a batch role assignment operation is currently running */
  isBatchRoleAssignmentRunning?: Maybe<Scalars["Boolean"]>;
  /** Get the result of the last batch role assignment execution */
  lastBatchRoleAssignmentExecution?: Maybe<SettingType>;
  /** Get all batch role assignments */
  batchRoleAssignments?: Maybe<Array<Maybe<BatchRoleAssignmentItem>>>;
  /** Get the list of OAuth client credential applications usage from Identify */
  oauthUsageHistory?: Maybe<Array<Maybe<OAuthUsageHistoryType>>>;
  notificationEmails?: Maybe<NotificationEmailsType>;
  log?: Maybe<LogType>;
  logsPagination?: Maybe<PaginationResultLogGraphType>;
  /** UTC year bounds for all logs accessible to the current administrator, independent of filters. */
  logYearRange: LogYearRange;
  /** Get all distinct EventIds from logs */
  distinctEventIds?: Maybe<Array<Maybe<LogEventIdInfo>>>;
  /** Download user profiles as Excel file */
  userProfilesExcel?: Maybe<Array<Maybe<UserProfileRoleType>>>;
  /** Download user roles assignment report as Excel file */
  userRolesAssignmentReportExcel?: Maybe<FileDownload>;
};

export type DirectoryQueryGetUserMyProfileArgs = {
  userId?: Maybe<Scalars["ID"]>;
};

export type DirectoryQueryUsersArgs = {
  filter?: Maybe<Scalars["String"]>;
};

export type DirectoryQueryUserArgs = {
  userId?: Maybe<Scalars["ID"]>;
};

export type DirectoryQueryUsersByEmailArgs = {
  email?: Maybe<Scalars["String"]>;
  excludeOrganizationId?: Maybe<Scalars["ID"]>;
};

export type DirectoryQueryUserByMitIdArgs = {
  mitID?: Maybe<Scalars["String"]>;
};

export type DirectoryQueryUserByKombitIdArgs = {
  kombitID?: Maybe<Scalars["String"]>;
};

export type DirectoryQueryUserByEidArgs = {
  eID?: Maybe<Scalars["String"]>;
};

export type DirectoryQueryUsersPaginationArgs = {
  pageParams?: Maybe<PageParamsInputType>;
};

export type DirectoryQueryOrganizationsArgs = {
  filter?: Maybe<Scalars["String"]>;
};

export type DirectoryQueryOrganizationsForRoleAssigneeArgs = {
  filter?: Maybe<Scalars["String"]>;
};

export type DirectoryQueryOrganizationArgs = {
  organizationId?: Maybe<Scalars["ID"]>;
};

export type DirectoryQueryApplicationArgs = {
  applicationId?: Maybe<Scalars["ID"]>;
};

export type DirectoryQueryRoleArgs = {
  roleId?: Maybe<Scalars["ID"]>;
};

export type DirectoryQueryRolesForUserArgs = {
  userId?: Maybe<Scalars["ID"]>;
};

export type DirectoryQueryProfilesArgs = {
  applicationId?: Maybe<Scalars["ID"]>;
};

export type DirectoryQueryProfilesByLevelOfUseArgs = {
  levelOfUse?: Maybe<LevelOfUse>;
};

export type DirectoryQueryProfileArgs = {
  profileId?: Maybe<Scalars["ID"]>;
};

export type DirectoryQuerySettingArgs = {
  key?: Maybe<Scalars["String"]>;
};

export type DirectoryQueryNotificationEmailsArgs = {
  filter?: Maybe<Scalars["String"]>;
};

export type DirectoryQueryLogArgs = {
  id: Scalars["Int"];
};

export type DirectoryQueryLogsPaginationArgs = {
  pageParams?: Maybe<PageParamsInputType>;
  filter?: Maybe<LogFilterInput>;
};

export type DirectoryQueryUserProfilesExcelArgs = {
  organizationIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type DirectoryQueryUserRolesAssignmentReportExcelArgs = {
  isSimulation?: Maybe<Scalars["Boolean"]>;
};

export enum EnrollmentStatus {
  Omitted = "OMITTED",
  Enrolled = "ENROLLED",
  NotEnrolled = "NOT_ENROLLED",
}

export type FileDownload = {
  /** The name of the file */
  fileName?: Maybe<Scalars["String"]>;
  /** The MIME type of the file */
  contentType?: Maybe<Scalars["String"]>;
  /** The file content as base64 encoded string */
  base64Data?: Maybe<Scalars["String"]>;
};

/** The level of use for the profile, indicating its scope and accessibility. */
export enum LevelOfUse {
  Organization = "ORGANIZATION",
  User = "USER",
}

/** Information about a log event ID including its description */
export type LogEventIdInfo = {
  /** The event ID value */
  id?: Maybe<Scalars["String"]>;
  /** The description of the event ID */
  description?: Maybe<Scalars["String"]>;
};

export type LogFilterInput = {
  level?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  eventIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  action?: Maybe<Scalars["String"]>;
  organizationIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  applicationIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
};

export type LogType = {
  id?: Maybe<Scalars["Int"]>;
  message?: Maybe<Scalars["String"]>;
  level?: Maybe<Scalars["String"]>;
  timestamp?: Maybe<Scalars["DateTimeOffset"]>;
  exception?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  eventId?: Maybe<Scalars["String"]>;
  eventDescription?: Maybe<Scalars["String"]>;
  ipAddress?: Maybe<Scalars["String"]>;
  machineName?: Maybe<Scalars["String"]>;
  logId?: Maybe<Scalars["ID"]>;
  userId?: Maybe<Scalars["ID"]>;
  userInfo?: Maybe<Scalars["String"]>;
  action?: Maybe<Scalars["String"]>;
  revisionType?: Maybe<Scalars["String"]>;
  revisionData?: Maybe<Scalars["String"]>;
  organizationId?: Maybe<Scalars["ID"]>;
  organizationName?: Maybe<Scalars["String"]>;
  applicationId?: Maybe<Scalars["ID"]>;
  applicationName?: Maybe<Scalars["String"]>;
};

export type LogYearRange = {
  /** UTC year of the earliest accessible log, or the current UTC year when no usable timestamp exists. */
  fromYear: Scalars["Int"];
  /** Current server UTC year. */
  toYear: Scalars["Int"];
};

export type NotificationEmailType = {
  emailId?: Maybe<Scalars["ID"]>;
  emailAddress?: Maybe<Scalars["String"]>;
  notificationOptions?: Maybe<NotificationOptionsType>;
};

export type NotificationEmailsType = {
  count?: Maybe<Scalars["Int"]>;
  items?: Maybe<Array<Maybe<NotificationEmailType>>>;
};

export type NotificationEmailsTypeItemsArgs = {
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type NotificationOptionsType = {
  onApplicationChanges?: Maybe<Scalars["Boolean"]>;
  onUserChanges?: Maybe<Scalars["Boolean"]>;
  onRoleChanges?: Maybe<Scalars["Boolean"]>;
  onRoleProfileChanges?: Maybe<Scalars["Boolean"]>;
  onOrganizationChanges?: Maybe<Scalars["Boolean"]>;
  onSystemChanges?: Maybe<Scalars["Boolean"]>;
  onUserOnboardingPerApplication?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type OAuthUsageHistoryType = {
  clientId?: Maybe<Scalars["String"]>;
  connectionName?: Maybe<Scalars["String"]>;
  latestUsage?: Maybe<Scalars["Int"]>;
  isClientCredentialFlow?: Maybe<Scalars["Boolean"]>;
};

export type OnboardingUserResultType = {
  userId?: Maybe<Scalars["ID"]>;
  adminEmails?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type OrganizationType = {
  organizationId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  vat?: Maybe<Scalars["String"]>;
  notifiedOnChange?: Maybe<Scalars["Boolean"]>;
  notifiedOnUserChange?: Maybe<Scalars["Boolean"]>;
  notifiedOnRoleAssignmentChange?: Maybe<Scalars["Boolean"]>;
  /** The roles assigned to the organization */
  assigneeRoles?: Maybe<Array<Maybe<RoleAssigneeType>>>;
  /** List of own users in the organization */
  users?: Maybe<OrganizationUserUserPaginationResult>;
  /** List of on-behalf-of users in the organization */
  oboUsers?: Maybe<OrganizationUserUserPaginationResult>;
};

export type OrganizationTypeUsersArgs = {
  pageParams?: Maybe<PageParamsInputType>;
};

export type OrganizationTypeOboUsersArgs = {
  pageParams?: Maybe<PageParamsInputType>;
};

export type OrganizationUserType = {
  userId?: Maybe<Scalars["ID"]>;
  organizationId?: Maybe<Scalars["ID"]>;
  organizationName?: Maybe<Scalars["String"]>;
  administrator?: Maybe<Scalars["Boolean"]>;
  email?: Maybe<Scalars["String"]>;
  firstname?: Maybe<Scalars["String"]>;
  lastname?: Maybe<Scalars["String"]>;
  mitID?: Maybe<Scalars["String"]>;
  kombitID?: Maybe<Scalars["String"]>;
  eID?: Maybe<Scalars["String"]>;
  enabled?: Maybe<Scalars["Boolean"]>;
  /** The roles assigned to the user */
  roles?: Maybe<Array<Maybe<UserRoleType>>>;
  lastLogin?: Maybe<Scalars["DateTime"]>;
  creationDate?: Maybe<Scalars["DateTime"]>;
};

export type OrganizationUserUserPaginationResult = {
  /** Items in the current page */
  items?: Maybe<Array<Maybe<OrganizationUserType>>>;
  /** Total number of items */
  total?: Maybe<Scalars["Int"]>;
};

export type PageParamsInputType = {
  /** Number of items per page */
  pageSize?: Maybe<Scalars["Int"]>;
  /** Current page number */
  currentPage?: Maybe<Scalars["Int"]>;
  /** search text */
  filter?: Maybe<Scalars["String"]>;
};

export type PaginationResultLogGraphType = {
  /** Items in the current page */
  items?: Maybe<Array<Maybe<LogType>>>;
  /** Total number of items */
  total?: Maybe<Scalars["Int"]>;
};

export type PaginationResultUserGraphType = {
  /** Items in the current page */
  items?: Maybe<Array<Maybe<UserType>>>;
  /** Total number of items */
  total?: Maybe<Scalars["Int"]>;
};

export type ProfileType = {
  profileId?: Maybe<Scalars["ID"]>;
  applicationId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  levelOfUse?: Maybe<LevelOfUse>;
  application?: Maybe<ApplicationType>;
  roles?: Maybe<Array<Maybe<RoleType>>>;
};

export type RemoveProfileRoleInputType = {
  profileId?: Maybe<Scalars["ID"]>;
  roleId?: Maybe<Scalars["ID"]>;
};

export type RemoveRoleApplicationInputType = {
  username?: Maybe<Scalars["String"]>;
};

export type RemoveUserRoleInputType = {
  userId?: Maybe<Scalars["ID"]>;
  roleId?: Maybe<Scalars["ID"]>;
  organizationId?: Maybe<Scalars["ID"]>;
};

export type RoleAssigneeType = {
  roleId?: Maybe<Scalars["ID"]>;
  organizationId?: Maybe<Scalars["ID"]>;
  isOnBehalf?: Maybe<Scalars["Boolean"]>;
  applicationId?: Maybe<Scalars["ID"]>;
  roleName?: Maybe<Scalars["String"]>;
  organizationName?: Maybe<Scalars["String"]>;
  applicationName?: Maybe<Scalars["String"]>;
};

export type RoleType = {
  roleId?: Maybe<Scalars["ID"]>;
  application?: Maybe<ApplicationType>;
  name?: Maybe<Scalars["String"]>;
  isOnBehalf?: Maybe<Scalars["Boolean"]>;
  attribute?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  assignees?: Maybe<Array<Maybe<OrganizationType>>>;
  users?: Maybe<UsersType>;
};

export type RoleTypeUsersArgs = {
  filter?: Maybe<Scalars["String"]>;
};

export enum SettingItemType {
  Unknown = "UNKNOWN",
  AutoDisableInactiveUserDuration = "AUTO_DISABLE_INACTIVE_USER_DURATION",
  AutoDeleteInactiveUserAfterDays = "AUTO_DELETE_INACTIVE_USER_AFTER_DAYS",
  AddEmailFromNotificationList = "ADD_EMAIL_FROM_NOTIFICATION_LIST",
  RemoveEmailFromNotificationList = "REMOVE_EMAIL_FROM_NOTIFICATION_LIST",
  UpdateApplicationChangesNotificationList = "UPDATE_APPLICATION_CHANGES_NOTIFICATION_LIST",
  UpdateUserChangesNotificationList = "UPDATE_USER_CHANGES_NOTIFICATION_LIST",
  UpdateRoleChangesNotificationList = "UPDATE_ROLE_CHANGES_NOTIFICATION_LIST",
  UpdateRoleProfileChangesNotificationList = "UPDATE_ROLE_PROFILE_CHANGES_NOTIFICATION_LIST",
  UpdateOrganizationChangesNotificationList = "UPDATE_ORGANIZATION_CHANGES_NOTIFICATION_LIST",
  UpdateSystemChangesNotificationList = "UPDATE_SYSTEM_CHANGES_NOTIFICATION_LIST",
  RemoveApplicationChangesNotificationList = "REMOVE_APPLICATION_CHANGES_NOTIFICATION_LIST",
  AddApplicationChangesNotificationList = "ADD_APPLICATION_CHANGES_NOTIFICATION_LIST",
  UploadBatchRoleAssignmentsCsvFile = "UPLOAD_BATCH_ROLE_ASSIGNMENTS_CSV_FILE",
  SaveBatchRoleAssignmentsSimulationResult = "SAVE_BATCH_ROLE_ASSIGNMENTS_SIMULATION_RESULT",
  SaveBatchRoleAssignmentsExecutionResult = "SAVE_BATCH_ROLE_ASSIGNMENTS_EXECUTION_RESULT",
}

export type SettingType = {
  settingId?: Maybe<Scalars["ID"]>;
  key?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
};

export type UpdateApplicationInputType = {
  applicationId?: Maybe<Scalars["Guid"]>;
  name?: Maybe<Scalars["String"]>;
  emailContacts?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type UpdateOrganizationInputType = {
  organizationId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  vat?: Maybe<Scalars["String"]>;
  notifiedOnChange?: Maybe<Scalars["Boolean"]>;
  notifiedOnUserChange?: Maybe<Scalars["Boolean"]>;
  notifiedOnRoleAssignmentChange?: Maybe<Scalars["Boolean"]>;
};

export type UpdateProfileInputType = {
  profileId?: Maybe<Scalars["Guid"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
};

export type UpdateRoleInputType = {
  roleId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  attribute?: Maybe<Scalars["String"]>;
  isOnBehalf?: Maybe<Scalars["Boolean"]>;
  description?: Maybe<Scalars["String"]>;
};

export type UpdateSettingInputType = {
  settingId?: Maybe<Scalars["Guid"]>;
  key?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  settingItemType?: Maybe<SettingItemType>;
};

export type UpdateUserInputType = {
  userId?: Maybe<Scalars["String"]>;
  administrator?: Maybe<Scalars["Boolean"]>;
  firstname?: Maybe<Scalars["String"]>;
  lastname?: Maybe<Scalars["String"]>;
  disabled?: Maybe<Scalars["Boolean"]>;
};

export type UploadCsvInputType = {
  /** The CSV file content as string */
  csvContent?: Maybe<Scalars["String"]>;
};

export type UserAuthenticatorRegistration = {
  identifyUserId?: Maybe<Scalars["ID"]>;
  enrollmentStatus: EnrollmentStatus;
};

export type UserCatalogSettings = {
  /** Whether MFA is configured for the User Catalog authentication connection. */
  mfaEnabled: Scalars["Boolean"];
};

export type UserProfileRoleType = {
  user?: Maybe<UserType>;
  organizationCVR?: Maybe<Scalars["String"]>;
  userRoles?: Maybe<Array<Maybe<UserRoleType>>>;
};

export type UserProfileType = {
  userId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  organizationId?: Maybe<Scalars["Guid"]>;
  isSuperAdmin?: Maybe<Scalars["Boolean"]>;
  isApplicationAdmin?: Maybe<Scalars["Boolean"]>;
  isUserAdmin?: Maybe<Scalars["Boolean"]>;
  isAdmin?: Maybe<Scalars["Boolean"]>;
  roles?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type UserRoleType = {
  roleId?: Maybe<Scalars["ID"]>;
  organizationId?: Maybe<Scalars["ID"]>;
  applicationId?: Maybe<Scalars["ID"]>;
  roleName?: Maybe<Scalars["String"]>;
  roleAttribute?: Maybe<Scalars["String"]>;
  isOnBehalf?: Maybe<Scalars["Boolean"]>;
  organizationName?: Maybe<Scalars["String"]>;
  organizationVat?: Maybe<Scalars["String"]>;
  applicationName?: Maybe<Scalars["String"]>;
};

export type UserType = {
  userId?: Maybe<Scalars["ID"]>;
  /** The user's Identify ID and User Catalog TOTP authenticator enrollment status. */
  authenticatorRegistration?: Maybe<UserAuthenticatorRegistration>;
  organization?: Maybe<OrganizationType>;
  administrator?: Maybe<Scalars["Boolean"]>;
  email?: Maybe<Scalars["String"]>;
  firstname?: Maybe<Scalars["String"]>;
  lastname?: Maybe<Scalars["String"]>;
  mitID?: Maybe<Scalars["String"]>;
  kombitID?: Maybe<Scalars["String"]>;
  eID?: Maybe<Scalars["String"]>;
  disabled?: Maybe<Scalars["Boolean"]>;
  roles?: Maybe<Array<Maybe<UserRoleType>>>;
  lastLogin?: Maybe<Scalars["DateTime"]>;
  creationDate?: Maybe<Scalars["DateTime"]>;
};

export type UsersType = {
  count?: Maybe<Scalars["Int"]>;
  items?: Maybe<Array<Maybe<UserType>>>;
};

export type UsersTypeItemsArgs = {
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type GetProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetProfileQuery = {
  userProfile?: Maybe<
    Pick<
      UserProfileType,
      | "isAdmin"
      | "isSuperAdmin"
      | "isUserAdmin"
      | "isApplicationAdmin"
      | "name"
      | "userId"
      | "organizationId"
      | "roles"
    >
  >;
};

export type GetUserCatalogSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserCatalogSettingsQuery = {
  userCatalogSettings?: Maybe<Pick<UserCatalogSettings, "mfaEnabled">>;
};

export type CreateApplicationMutationVariables = Exact<{
  input: CreateApplicationInputType;
}>;

export type CreateApplicationMutation = {
  createApplication?: Maybe<ApplicationDetailsPartsFragment>;
};

export type DeleteApplicationMutationVariables = Exact<{
  applicationID: Scalars["ID"];
}>;

export type DeleteApplicationMutation = Pick<
  DirectoryMutation,
  "deleteApplication"
>;

export type UpdateApplicationMutationVariables = Exact<{
  input: UpdateApplicationInputType;
}>;

export type UpdateApplicationMutation = {
  updateApplication?: Maybe<ApplicationDetailsPartsFragment>;
};

export type GetUsersByEmailQueryVariables = Exact<{
  email: Scalars["String"];
  excludeOrganizationId: Scalars["ID"];
}>;

export type GetUsersByEmailQuery = {
  usersByEmail?: Maybe<
    Array<
      Maybe<
        Pick<UserType, "userId" | "email" | "firstname" | "lastname"> & {
          organization?: Maybe<Pick<OrganizationType, "name" | "vat">>;
          roles?: Maybe<
            Array<
              Maybe<
                Pick<
                  UserRoleType,
                  | "roleId"
                  | "organizationId"
                  | "applicationId"
                  | "roleName"
                  | "organizationName"
                  | "applicationName"
                >
              >
            >
          >;
        }
      >
    >
  >;
};

export type AssignUserRoleOnBehalfOfMutationVariables = Exact<{
  input: AssignUserRoleOnBehalfOfInputfType;
}>;

export type AssignUserRoleOnBehalfOfMutation = Pick<
  DirectoryMutation,
  "assignUserRoleOnBehalfOf"
>;

export type GetRoleAssigneesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRoleAssigneesQuery = {
  roleAssignees?: Maybe<Array<Maybe<RoleAssigneePartsFragment>>>;
};

export type UpdateNotificationOptionsMutationVariables = Exact<{
  emailId: Scalars["ID"];
  input: CreateOrUpdateNotificationOptionsInputType;
  settingItemType: SettingItemType;
  activate?: Maybe<Scalars["Boolean"]>;
  applicationName?: Maybe<Scalars["String"]>;
}>;

export type UpdateNotificationOptionsMutation = Pick<
  DirectoryMutation,
  "updateNotificationOptions"
>;

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInputType;
}>;

export type CreateOrganizationMutation = {
  createOrganization?: Maybe<OrganizationPartsFragment>;
};

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars["ID"];
}>;

export type DeleteOrganizationMutation = Pick<
  DirectoryMutation,
  "deleteOrganization"
>;

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInputType;
}>;

export type UpdateOrganizationMutation = {
  updateOrganization?: Maybe<OrganizationPartsFragment>;
};

export type GetProfilesByLevelOfUseQueryVariables = Exact<{
  levelOfUse: LevelOfUse;
}>;

export type GetProfilesByLevelOfUseQuery = {
  profilesByLevelOfUse?: Maybe<
    Array<
      Maybe<
        Pick<
          ProfileType,
          "profileId" | "name" | "description" | "levelOfUse"
        > & {
          application?: Maybe<Pick<ApplicationType, "applicationId" | "name">>;
          roles?: Maybe<
            Array<
              Maybe<
                Pick<RoleType, "roleId" | "name"> & {
                  application?: Maybe<
                    Pick<ApplicationType, "applicationId" | "name">
                  >;
                }
              >
            >
          >;
        }
      >
    >
  >;
};

export type ResetUserPasswordMutationVariables = Exact<{
  input: ChangeUserPasswordInputType;
}>;

export type ResetUserPasswordMutation = Pick<
  DirectoryMutation,
  "changeUserPassword"
>;

export type GetBasicOrganisationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetBasicOrganisationsQuery = {
  organizationsForRoleAssignee?: Maybe<
    Pick<BasicOrganizationsType, "count"> & {
      items?: Maybe<Array<Maybe<BasicOrganizationPartsFragment>>>;
    }
  >;
};

export type UserProfilesExcelBatchQueryVariables = Exact<{
  organizationIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type UserProfilesExcelBatchQuery = {
  userProfilesExcel?: Maybe<
    Array<
      Maybe<
        Pick<UserProfileRoleType, "organizationCVR"> & {
          user?: Maybe<
            Pick<
              UserType,
              | "userId"
              | "administrator"
              | "email"
              | "firstname"
              | "lastname"
              | "mitID"
              | "kombitID"
              | "eID"
              | "disabled"
              | "lastLogin"
              | "creationDate"
            > & {
              organization?: Maybe<
                Pick<OrganizationType, "organizationId" | "name">
              >;
            }
          >;
          userRoles?: Maybe<
            Array<
              Maybe<
                Pick<
                  UserRoleType,
                  | "roleName"
                  | "roleAttribute"
                  | "organizationName"
                  | "organizationVat"
                  | "applicationName"
                  | "isOnBehalf"
                >
              >
            >
          >;
        }
      >
    >
  >;
};

export type ApplicationDetailsPartsFragment = Pick<
  ApplicationType,
  "applicationId" | "name" | "emailContacts"
>;

export type LogPartsFragment = Pick<
  LogType,
  | "id"
  | "message"
  | "level"
  | "timestamp"
  | "exception"
  | "type"
  | "eventId"
  | "eventDescription"
  | "ipAddress"
  | "machineName"
  | "logId"
  | "userId"
  | "action"
  | "revisionType"
  | "revisionData"
  | "organizationId"
  | "applicationId"
  | "userInfo"
  | "organizationName"
  | "applicationName"
>;

export type NotificationEmailPartsFragment = Pick<
  NotificationEmailType,
  "emailId" | "emailAddress"
> & {
  notificationOptions?: Maybe<
    Pick<
      NotificationOptionsType,
      | "onApplicationChanges"
      | "onUserChanges"
      | "onRoleChanges"
      | "onRoleProfileChanges"
      | "onOrganizationChanges"
      | "onSystemChanges"
      | "onUserOnboardingPerApplication"
    >
  >;
};

export type OrganizationPartsFragment = Pick<
  OrganizationType,
  | "name"
  | "organizationId"
  | "vat"
  | "notifiedOnChange"
  | "notifiedOnUserChange"
  | "notifiedOnRoleAssignmentChange"
> & {
  users?: Maybe<Pick<OrganizationUserUserPaginationResult, "total">>;
  oboUsers?: Maybe<Pick<OrganizationUserUserPaginationResult, "total">>;
};

export type BasicOrganizationPartsFragment = Pick<
  BasicOrganizationType,
  "name" | "organizationId" | "vat" | "userCount"
>;

export type OrganizationUserPartsFragment = Pick<
  OrganizationUserType,
  | "userId"
  | "email"
  | "firstname"
  | "lastname"
  | "administrator"
  | "organizationId"
  | "organizationName"
  | "mitID"
  | "kombitID"
  | "eID"
  | "enabled"
  | "lastLogin"
  | "creationDate"
>;

export type ProfilePartsFragment = Pick<
  ProfileType,
  "profileId" | "applicationId" | "name" | "description" | "levelOfUse"
>;

export type RoleAssigneePartsFragment = Pick<
  RoleAssigneeType,
  | "roleId"
  | "organizationId"
  | "applicationId"
  | "roleName"
  | "organizationName"
  | "applicationName"
>;

export type RolePartsFragment = Pick<
  RoleType,
  "name" | "roleId" | "description" | "attribute" | "isOnBehalf"
>;

export type SettingPartsFragment = Pick<
  SettingType,
  "settingId" | "key" | "value"
>;

export type UserPartsFragment = Pick<
  UserType,
  | "userId"
  | "email"
  | "firstname"
  | "lastname"
  | "administrator"
  | "disabled"
  | "mitID"
  | "kombitID"
  | "eID"
  | "lastLogin"
  | "creationDate"
> & {
  organization?: Maybe<
    Pick<OrganizationType, "organizationId" | "vat" | "name">
  >;
};

export type OboUserPartsFragment = Pick<
  UserType,
  "userId" | "email" | "firstname" | "lastname" | "lastLogin" | "creationDate"
> & {
  organization?: Maybe<
    Pick<OrganizationType, "organizationId" | "vat" | "name">
  >;
};

export type UserRolePartsFragment = Pick<
  UserRoleType,
  | "roleId"
  | "organizationId"
  | "applicationId"
  | "roleName"
  | "organizationName"
  | "applicationName"
>;

export type GetSelectableRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetSelectableRolesQuery = {
  roles?: Maybe<
    Array<
      Maybe<
        Pick<RoleType, "roleId" | "attribute" | "name"> & {
          application?: Maybe<Pick<ApplicationType, "applicationId" | "name">>;
        }
      >
    >
  >;
};

export type GetApplicationQueryVariables = Exact<{
  applicationId?: Maybe<Scalars["ID"]>;
}>;

export type GetApplicationQuery = {
  application?: Maybe<
    {
      roles?: Maybe<
        Array<
          Maybe<
            Pick<RoleType, "description" | "roleId" | "name"> & {
              users?: Maybe<Pick<UsersType, "count">>;
            }
          >
        >
      >;
      profiles?: Maybe<
        Array<
          Maybe<
            Pick<
              ProfileType,
              "profileId" | "name" | "description" | "levelOfUse"
            >
          >
        >
      >;
    } & ApplicationDetailsPartsFragment
  >;
};

export type GetApplicationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetApplicationsQuery = {
  applications?: Maybe<
    Array<
      Maybe<
        Pick<ApplicationType, "applicationId" | "name"> & {
          roles?: Maybe<Array<Maybe<Pick<RoleType, "name">>>>;
        }
      >
    >
  >;
};

export type GetBatchRoleAssignmentsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetBatchRoleAssignmentsQuery = {
  batchRoleAssignments?: Maybe<
    Array<
      Maybe<
        Pick<
          BatchRoleAssignmentItem,
          | "email"
          | "roleName"
          | "roleId"
          | "orgCVR"
          | "organizationId"
          | "organizationName"
        >
      >
    >
  >;
};

export type IsBatchRoleAssignmentRunningQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IsBatchRoleAssignmentRunningQuery = Pick<
  DirectoryQuery,
  "isBatchRoleAssignmentRunning"
>;

export type LastBatchRoleAssignmentSimulationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LastBatchRoleAssignmentSimulationQuery = {
  lastBatchRoleAssignmentSimulation?: Maybe<
    Pick<SettingType, "settingId" | "key" | "value">
  >;
};

export type LastBatchRoleAssignmentExecutionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LastBatchRoleAssignmentExecutionQuery = {
  lastBatchRoleAssignmentExecution?: Maybe<
    Pick<SettingType, "settingId" | "key" | "value">
  >;
};

export type UploadBatchRoleAssignmentsCsvMutationVariables = Exact<{
  input: UploadCsvInputType;
}>;

export type UploadBatchRoleAssignmentsCsvMutation = {
  uploadBatchRoleAssignmentsCsv?: Maybe<
    Pick<BatchRolesUploadResult, "success" | "errors"> & {
      validRoleAssignmentItems?: Maybe<
        Array<
          Maybe<
            Pick<
              BatchRoleAssignmentItem,
              "email" | "roleName" | "roleId" | "orgCVR" | "organizationId"
            >
          >
        >
      >;
    }
  >;
};

export type DoBatchRoleAssignmentsMutationVariables = Exact<{
  input: BatchRoleAssignmentOption;
}>;

export type DoBatchRoleAssignmentsMutation = {
  doBatchRoleAssignments?: Maybe<
    Pick<
      BatchRoleAssignmentResult,
      | "isSimulation"
      | "success"
      | "errors"
      | "totalAssignments"
      | "totalUsersAssignment"
      | "processedAt"
      | "finishedAt"
    > & {
      assignedRoles?: Maybe<
        Array<
          Maybe<
            Pick<
              BatchRoleAssignmentItemResult,
              "email" | "roleName" | "roleId" | "orgCVR" | "organizationId"
            >
          >
        >
      >;
    }
  >;
};

export type UserRolesAssignmentReportExcelQueryVariables = Exact<{
  isSimulation?: Maybe<Scalars["Boolean"]>;
}>;

export type UserRolesAssignmentReportExcelQuery = {
  userRolesAssignmentReportExcel?: Maybe<
    Pick<FileDownload, "fileName" | "contentType" | "base64Data">
  >;
};

export type OauthUsageHistoryQueryVariables = Exact<{ [key: string]: never }>;

export type OauthUsageHistoryQuery = {
  oauthUsageHistory?: Maybe<
    Array<
      Maybe<
        Pick<
          OAuthUsageHistoryType,
          | "connectionName"
          | "clientId"
          | "latestUsage"
          | "isClientCredentialFlow"
        >
      >
    >
  >;
};

export type GetLogQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type GetLogQuery = { log?: Maybe<LogPartsFragment> };

export type GetLogsPaginationQueryVariables = Exact<{
  pageParams: PageParamsInputType;
  filter?: Maybe<LogFilterInput>;
}>;

export type GetLogsPaginationQuery = {
  logsPagination?: Maybe<
    Pick<PaginationResultLogGraphType, "total"> & {
      items?: Maybe<Array<Maybe<LogPartsFragment>>>;
    }
  >;
};

export type GetLogYearRangeQueryVariables = Exact<{ [key: string]: never }>;

export type GetLogYearRangeQuery = {
  logYearRange: Pick<LogYearRange, "fromYear" | "toYear">;
};

export type GetDistinctEventIdsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDistinctEventIdsQuery = {
  distinctEventIds?: Maybe<
    Array<Maybe<Pick<LogEventIdInfo, "id" | "description">>>
  >;
};

export type GetUserMyProfileQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetUserMyProfileQuery = {
  getUserMyProfile?: Maybe<
    {
      roles?: Maybe<
        Array<
          Maybe<
            Pick<
              UserRoleType,
              | "roleId"
              | "organizationId"
              | "applicationId"
              | "roleName"
              | "organizationName"
              | "applicationName"
            >
          >
        >
      >;
    } & UserPartsFragment
  >;
};

export type GetOrganizationQueryVariables = Exact<{
  organizationId?: Maybe<Scalars["ID"]>;
  pageParams: PageParamsInputType;
}>;

export type GetOrganizationQuery = {
  organization?: Maybe<
    Pick<
      OrganizationType,
      | "name"
      | "organizationId"
      | "vat"
      | "notifiedOnChange"
      | "notifiedOnUserChange"
      | "notifiedOnRoleAssignmentChange"
    > & {
      users?: Maybe<
        Pick<OrganizationUserUserPaginationResult, "total"> & {
          items?: Maybe<Array<Maybe<OrganizationUserPartsFragment>>>;
        }
      >;
      oboUsers?: Maybe<
        Pick<OrganizationUserUserPaginationResult, "total"> & {
          items?: Maybe<Array<Maybe<OrganizationUserPartsFragment>>>;
        }
      >;
      assigneeRoles?: Maybe<
        Array<
          Maybe<
            Pick<
              RoleAssigneeType,
              | "roleId"
              | "roleName"
              | "isOnBehalf"
              | "applicationId"
              | "applicationName"
              | "organizationId"
              | "organizationName"
            >
          >
        >
      >;
    }
  >;
};

export type GetOrganisationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrganisationsQuery = {
  organizations?: Maybe<
    Pick<BasicOrganizationsType, "count"> & {
      items?: Maybe<Array<Maybe<BasicOrganizationPartsFragment>>>;
    }
  >;
};

export type GetProfileApplicationQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetProfileApplicationQuery = {
  profile?: Maybe<
    {
      application?: Maybe<
        Pick<ApplicationType, "applicationId" | "name"> & {
          roles?: Maybe<Array<Maybe<Pick<RoleType, "roleId" | "name">>>>;
        }
      >;
      roles?: Maybe<Array<Maybe<Pick<RoleType, "roleId" | "name">>>>;
    } & ProfilePartsFragment
  >;
};

export type AddProfileRoleMutationVariables = Exact<{
  input: AddProfileRoleInputType;
}>;

export type AddProfileRoleMutation = Pick<DirectoryMutation, "addProfileRole">;

export type CreateProfileMutationVariables = Exact<{
  input: CreateProfileInputType;
}>;

export type CreateProfileMutation = {
  createProfile?: Maybe<ProfilePartsFragment>;
};

export type DeleteProfileMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteProfileMutation = Pick<DirectoryMutation, "deleteProfile">;

export type RemoveProfileRoleMutationVariables = Exact<{
  input: RemoveProfileRoleInputType;
}>;

export type RemoveProfileRoleMutation = Pick<
  DirectoryMutation,
  "removeProfileRole"
>;

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInputType;
}>;

export type UpdateProfileMutation = {
  updateProfile?: Maybe<ProfilePartsFragment>;
};

export type GetRoleQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetRoleQuery = {
  role?: Maybe<
    {
      application?: Maybe<Pick<ApplicationType, "applicationId" | "name">>;
      assignees?: Maybe<
        Array<Maybe<Pick<OrganizationType, "organizationId" | "name">>>
      >;
      users?: Maybe<{
        items?: Maybe<
          Array<
            Maybe<
              Pick<UserType, "email" | "userId" | "firstname" | "lastname"> & {
                organization?: Maybe<Pick<OrganizationType, "name">>;
              }
            >
          >
        >;
      }>;
    } & RolePartsFragment
  >;
};

export type AddRoleAssigneeMutationVariables = Exact<{
  input: AddRoleAssigneeInputType;
}>;

export type AddRoleAssigneeMutation = Pick<
  DirectoryMutation,
  "addRoleAssignee"
>;

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInputType;
}>;

export type CreateRoleMutation = { createRole?: Maybe<RolePartsFragment> };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteRoleMutation = Pick<DirectoryMutation, "deleteRole">;

export type RemoveRoleAssigneeMutationVariables = Exact<{
  roleId: Scalars["ID"];
  organizationId: Scalars["ID"];
}>;

export type RemoveRoleAssigneeMutation = Pick<
  DirectoryMutation,
  "removeRoleAssignee"
>;

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInputType;
}>;

export type UpdateRoleMutation = { updateRole?: Maybe<RolePartsFragment> };

export type GetNotificationEmailsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetNotificationEmailsQuery = {
  notificationEmails?: Maybe<
    Pick<NotificationEmailsType, "count"> & {
      items?: Maybe<Array<Maybe<NotificationEmailPartsFragment>>>;
    }
  >;
};

export type AddNotificationEmailMutationVariables = Exact<{
  input: AddNotificationEmailInputType;
}>;

export type AddNotificationEmailMutation = {
  addNotificationEmail?: Maybe<NotificationEmailPartsFragment>;
};

export type DeleteNotificationEmailMutationVariables = Exact<{
  emailId: Scalars["ID"];
}>;

export type DeleteNotificationEmailMutation = Pick<
  DirectoryMutation,
  "deleteNotificationEmail"
>;

export type GetSettingByKeyQueryVariables = Exact<{
  key: Scalars["String"];
}>;

export type GetSettingByKeyQuery = { setting?: Maybe<SettingPartsFragment> };

export type UpdateSettingMutationVariables = Exact<{
  input: UpdateSettingInputType;
}>;

export type UpdateSettingMutation = {
  updateSetting?: Maybe<SettingPartsFragment>;
};

export type GetUserQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetUserQuery = {
  user?: Maybe<
    {
      roles?: Maybe<
        Array<
          Maybe<
            Pick<
              UserRoleType,
              | "roleId"
              | "organizationId"
              | "applicationId"
              | "roleName"
              | "organizationName"
              | "applicationName"
            >
          >
        >
      >;
      authenticatorRegistration?: Maybe<
        Pick<UserAuthenticatorRegistration, "enrollmentStatus">
      >;
    } & UserPartsFragment
  >;
};

export type GetOboUserQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetOboUserQuery = {
  user?: Maybe<
    {
      roles?: Maybe<
        Array<
          Maybe<
            Pick<
              UserRoleType,
              | "roleId"
              | "organizationId"
              | "applicationId"
              | "roleName"
              | "organizationName"
              | "applicationName"
            >
          >
        >
      >;
    } & OboUserPartsFragment
  >;
};

export type GetRolesForUserQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetRolesForUserQuery = {
  rolesForUser?: Maybe<Array<Maybe<RoleAssigneePartsFragment>>>;
};

export type AddUserRoleMutationVariables = Exact<{
  input: AddUserRoleInputType;
}>;

export type AddUserRoleMutation = Pick<DirectoryMutation, "addUserRole">;

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInputType;
}>;

export type CreateUserMutation = {
  createUser?: Maybe<
    {
      roles?: Maybe<
        Array<
          Maybe<
            Pick<
              UserRoleType,
              | "roleId"
              | "organizationId"
              | "applicationId"
              | "roleName"
              | "organizationName"
              | "applicationName"
            >
          >
        >
      >;
    } & UserPartsFragment
  >;
};

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars["ID"];
}>;

export type DeleteUserMutation = Pick<DirectoryMutation, "deleteUser">;

export type MigrateUserToNonEidOrganizationMutationVariables = Exact<{
  userId: Scalars["ID"];
}>;

export type MigrateUserToNonEidOrganizationMutation = {
  migrateUserToNonEidOrganization?: Maybe<Pick<UserType, "userId">>;
};

export type RemoveUserRoleMutationVariables = Exact<{
  input: RemoveUserRoleInputType;
}>;

export type RemoveUserRoleMutation = Pick<DirectoryMutation, "removeUserRole">;

export type ResetUserAuthenticatorRegistrationMutationVariables = Exact<{
  userId: Scalars["ID"];
}>;

export type ResetUserAuthenticatorRegistrationMutation = Pick<
  DirectoryMutation,
  "resetUserAuthenticatorRegistration"
>;

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInputType;
}>;

export type UpdateUserMutation = {
  updateUser?: Maybe<
    {
      roles?: Maybe<
        Array<
          Maybe<
            Pick<
              UserRoleType,
              | "roleId"
              | "organizationId"
              | "applicationId"
              | "roleName"
              | "organizationName"
              | "applicationName"
            >
          >
        >
      >;
    } & UserPartsFragment
  >;
};

export type GetUsersPaginationQueryVariables = Exact<{
  pageParams: PageParamsInputType;
}>;

export type GetUsersPaginationQuery = {
  usersPagination?: Maybe<
    Pick<PaginationResultUserGraphType, "total"> & {
      items?: Maybe<
        Array<
          Maybe<
            Pick<
              UserType,
              | "userId"
              | "firstname"
              | "lastname"
              | "email"
              | "mitID"
              | "kombitID"
              | "eID"
              | "administrator"
              | "disabled"
              | "lastLogin"
              | "creationDate"
            > & {
              organization?: Maybe<
                Pick<OrganizationType, "organizationId" | "name">
              >;
            }
          >
        >
      >;
    }
  >;
};

export const ApplicationDetailsPartsFragmentDoc = gql`
  fragment ApplicationDetailsParts on ApplicationType {
    applicationId
    name
    emailContacts
  }
`;
export const LogPartsFragmentDoc = gql`
  fragment LogParts on LogType {
    id
    message
    level
    timestamp
    exception
    type
    eventId
    eventDescription
    ipAddress
    machineName
    logId
    userId
    action
    revisionType
    revisionData
    organizationId
    applicationId
    userInfo
    organizationName
    applicationName
  }
`;
export const NotificationEmailPartsFragmentDoc = gql`
  fragment NotificationEmailParts on NotificationEmailType {
    emailId
    emailAddress
    notificationOptions {
      onApplicationChanges
      onUserChanges
      onRoleChanges
      onRoleProfileChanges
      onOrganizationChanges
      onSystemChanges
      onUserOnboardingPerApplication
    }
  }
`;
export const OrganizationPartsFragmentDoc = gql`
  fragment OrganizationParts on OrganizationType {
    name
    organizationId
    vat
    notifiedOnChange
    notifiedOnUserChange
    notifiedOnRoleAssignmentChange
    users {
      total
    }
    oboUsers {
      total
    }
  }
`;
export const BasicOrganizationPartsFragmentDoc = gql`
  fragment BasicOrganizationParts on BasicOrganizationType {
    name
    organizationId
    vat
    userCount
  }
`;
export const OrganizationUserPartsFragmentDoc = gql`
  fragment OrganizationUserParts on OrganizationUserType {
    userId
    email
    firstname
    lastname
    administrator
    organizationId
    organizationName
    mitID
    kombitID
    eID
    enabled
    lastLogin
    creationDate
  }
`;
export const ProfilePartsFragmentDoc = gql`
  fragment ProfileParts on ProfileType {
    profileId
    applicationId
    name
    description
    levelOfUse
  }
`;
export const RoleAssigneePartsFragmentDoc = gql`
  fragment RoleAssigneeParts on RoleAssigneeType {
    roleId
    organizationId
    applicationId
    roleName
    organizationName
    applicationName
  }
`;
export const RolePartsFragmentDoc = gql`
  fragment RoleParts on RoleType {
    name
    roleId
    description
    attribute
    isOnBehalf
  }
`;
export const SettingPartsFragmentDoc = gql`
  fragment SettingParts on SettingType {
    settingId
    key
    value
  }
`;
export const UserPartsFragmentDoc = gql`
  fragment UserParts on UserType {
    userId
    email
    firstname
    lastname
    administrator
    disabled
    organization {
      organizationId
      vat
      name
    }
    mitID
    kombitID
    eID
    lastLogin
    creationDate
  }
`;
export const OboUserPartsFragmentDoc = gql`
  fragment OboUserParts on UserType {
    userId
    email
    firstname
    lastname
    organization {
      organizationId
      vat
      name
    }
    lastLogin
    creationDate
  }
`;
export const UserRolePartsFragmentDoc = gql`
  fragment UserRoleParts on UserRoleType {
    roleId
    organizationId
    applicationId
    roleName
    organizationName
    applicationName
  }
`;
export const GetProfileDocument = gql`
  query GetProfile {
    userProfile {
      isAdmin
      isSuperAdmin
      isUserAdmin
      isApplicationAdmin
      name
      userId
      organizationId
      roles
    }
  }
`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a Vue component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProfileQuery();
 */
export function useGetProfileQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetProfileQuery,
        GetProfileQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetProfileQuery,
          GetProfileQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetProfileQuery,
          GetProfileQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetProfileQuery,
    GetProfileQueryVariables
  >(GetProfileDocument, {}, options);
}
export type GetProfileQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<GetProfileQuery, GetProfileQueryVariables>;
export const GetUserCatalogSettingsDocument = gql`
  query GetUserCatalogSettings {
    userCatalogSettings {
      mfaEnabled
    }
  }
`;

/**
 * __useGetUserCatalogSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetUserCatalogSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCatalogSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserCatalogSettingsQuery();
 */
export function useGetUserCatalogSettingsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetUserCatalogSettingsQuery,
        GetUserCatalogSettingsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetUserCatalogSettingsQuery,
          GetUserCatalogSettingsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetUserCatalogSettingsQuery,
          GetUserCatalogSettingsQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetUserCatalogSettingsQuery,
    GetUserCatalogSettingsQueryVariables
  >(GetUserCatalogSettingsDocument, {}, options);
}
export type GetUserCatalogSettingsQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetUserCatalogSettingsQuery,
    GetUserCatalogSettingsQueryVariables
  >;
export const CreateApplicationDocument = gql`
  mutation CreateApplication($input: CreateApplicationInputType!) {
    createApplication(input: $input) {
      ...ApplicationDetailsParts
    }
  }
  ${ApplicationDetailsPartsFragmentDoc}
`;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateApplicationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateApplicationMutation,
        CreateApplicationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateApplicationMutation,
          CreateApplicationMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    CreateApplicationMutation,
    CreateApplicationMutationVariables
  >(CreateApplicationDocument, options);
}
export type CreateApplicationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateApplicationMutation,
    CreateApplicationMutationVariables
  >;
export const DeleteApplicationDocument = gql`
  mutation DeleteApplication($applicationID: ID!) {
    deleteApplication(applicationId: $applicationID)
  }
`;

/**
 * __useDeleteApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteApplicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApplicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteApplicationMutation({
 *   variables: {
 *     applicationID: // value for 'applicationID'
 *   },
 * });
 */
export function useDeleteApplicationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteApplicationMutation,
        DeleteApplicationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteApplicationMutation,
          DeleteApplicationMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    DeleteApplicationMutation,
    DeleteApplicationMutationVariables
  >(DeleteApplicationDocument, options);
}
export type DeleteApplicationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DeleteApplicationMutation,
    DeleteApplicationMutationVariables
  >;
export const UpdateApplicationDocument = gql`
  mutation UpdateApplication($input: UpdateApplicationInputType!) {
    updateApplication(input: $input) {
      ...ApplicationDetailsParts
    }
  }
  ${ApplicationDetailsPartsFragmentDoc}
`;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateApplicationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateApplicationMutation,
        UpdateApplicationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateApplicationMutation,
          UpdateApplicationMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    UpdateApplicationMutation,
    UpdateApplicationMutationVariables
  >(UpdateApplicationDocument, options);
}
export type UpdateApplicationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateApplicationMutation,
    UpdateApplicationMutationVariables
  >;
export const GetUsersByEmailDocument = gql`
  query GetUsersByEmail($email: String!, $excludeOrganizationId: ID!) {
    usersByEmail(email: $email, excludeOrganizationId: $excludeOrganizationId) {
      userId
      email
      firstname
      lastname
      organization {
        name
        vat
      }
      roles {
        roleId
        organizationId
        applicationId
        roleName
        organizationName
        applicationName
      }
    }
  }
`;

/**
 * __useGetUsersByEmailQuery__
 *
 * To run a query within a Vue component, call `useGetUsersByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByEmailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUsersByEmailQuery({
 *   email: // value for 'email'
 *   excludeOrganizationId: // value for 'excludeOrganizationId'
 * });
 */
export function useGetUsersByEmailQuery(
  variables:
    | GetUsersByEmailQueryVariables
    | VueCompositionApi.Ref<GetUsersByEmailQueryVariables>
    | ReactiveFunction<GetUsersByEmailQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetUsersByEmailQuery,
        GetUsersByEmailQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetUsersByEmailQuery,
          GetUsersByEmailQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetUsersByEmailQuery,
          GetUsersByEmailQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetUsersByEmailQuery,
    GetUsersByEmailQueryVariables
  >(GetUsersByEmailDocument, variables, options);
}
export type GetUsersByEmailQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetUsersByEmailQuery,
    GetUsersByEmailQueryVariables
  >;
export const AssignUserRoleOnBehalfOfDocument = gql`
  mutation AssignUserRoleOnBehalfOf(
    $input: AssignUserRoleOnBehalfOfInputfType!
  ) {
    assignUserRoleOnBehalfOf(input: $input)
  }
`;

/**
 * __useAssignUserRoleOnBehalfOfMutation__
 *
 * To run a mutation, you first call `useAssignUserRoleOnBehalfOfMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserRoleOnBehalfOfMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignUserRoleOnBehalfOfMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAssignUserRoleOnBehalfOfMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AssignUserRoleOnBehalfOfMutation,
        AssignUserRoleOnBehalfOfMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AssignUserRoleOnBehalfOfMutation,
          AssignUserRoleOnBehalfOfMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    AssignUserRoleOnBehalfOfMutation,
    AssignUserRoleOnBehalfOfMutationVariables
  >(AssignUserRoleOnBehalfOfDocument, options);
}
export type AssignUserRoleOnBehalfOfMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AssignUserRoleOnBehalfOfMutation,
    AssignUserRoleOnBehalfOfMutationVariables
  >;
export const GetRoleAssigneesDocument = gql`
  query getRoleAssignees {
    roleAssignees {
      ...RoleAssigneeParts
    }
  }
  ${RoleAssigneePartsFragmentDoc}
`;

/**
 * __useGetRoleAssigneesQuery__
 *
 * To run a query within a Vue component, call `useGetRoleAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleAssigneesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRoleAssigneesQuery();
 */
export function useGetRoleAssigneesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetRoleAssigneesQuery,
        GetRoleAssigneesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetRoleAssigneesQuery,
          GetRoleAssigneesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetRoleAssigneesQuery,
          GetRoleAssigneesQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetRoleAssigneesQuery,
    GetRoleAssigneesQueryVariables
  >(GetRoleAssigneesDocument, {}, options);
}
export type GetRoleAssigneesQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetRoleAssigneesQuery,
    GetRoleAssigneesQueryVariables
  >;
export const UpdateNotificationOptionsDocument = gql`
  mutation UpdateNotificationOptions(
    $emailId: ID!
    $input: CreateOrUpdateNotificationOptionsInputType!
    $settingItemType: SettingItemType!
    $activate: Boolean
    $applicationName: String
  ) {
    updateNotificationOptions(
      emailId: $emailId
      input: $input
      settingItemType: $settingItemType
      activate: $activate
      applicationName: $applicationName
    )
  }
`;

/**
 * __useUpdateNotificationOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationOptionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationOptionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateNotificationOptionsMutation({
 *   variables: {
 *     emailId: // value for 'emailId'
 *     input: // value for 'input'
 *     settingItemType: // value for 'settingItemType'
 *     activate: // value for 'activate'
 *     applicationName: // value for 'applicationName'
 *   },
 * });
 */
export function useUpdateNotificationOptionsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateNotificationOptionsMutation,
        UpdateNotificationOptionsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateNotificationOptionsMutation,
          UpdateNotificationOptionsMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    UpdateNotificationOptionsMutation,
    UpdateNotificationOptionsMutationVariables
  >(UpdateNotificationOptionsDocument, options);
}
export type UpdateNotificationOptionsMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateNotificationOptionsMutation,
    UpdateNotificationOptionsMutationVariables
  >;
export const CreateOrganizationDocument = gql`
  mutation CreateOrganization($input: CreateOrganizationInputType!) {
    createOrganization(input: $input) {
      ...OrganizationParts
    }
  }
  ${OrganizationPartsFragmentDoc}
`;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOrganizationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateOrganizationMutation,
        CreateOrganizationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateOrganizationMutation,
          CreateOrganizationMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >(CreateOrganizationDocument, options);
}
export type CreateOrganizationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >;
export const DeleteOrganizationDocument = gql`
  mutation DeleteOrganization($organizationId: ID!) {
    deleteOrganization(organizationId: $organizationId)
  }
`;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOrganizationMutation({
 *   variables: {
 *     organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteOrganizationMutation,
        DeleteOrganizationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteOrganizationMutation,
          DeleteOrganizationMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    DeleteOrganizationMutation,
    DeleteOrganizationMutationVariables
  >(DeleteOrganizationDocument, options);
}
export type DeleteOrganizationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DeleteOrganizationMutation,
    DeleteOrganizationMutationVariables
  >;
export const UpdateOrganizationDocument = gql`
  mutation UpdateOrganization($input: UpdateOrganizationInputType!) {
    updateOrganization(input: $input) {
      ...OrganizationParts
    }
  }
  ${OrganizationPartsFragmentDoc}
`;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOrganizationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateOrganizationMutation,
        UpdateOrganizationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateOrganizationMutation,
          UpdateOrganizationMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    UpdateOrganizationMutation,
    UpdateOrganizationMutationVariables
  >(UpdateOrganizationDocument, options);
}
export type UpdateOrganizationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateOrganizationMutation,
    UpdateOrganizationMutationVariables
  >;
export const GetProfilesByLevelOfUseDocument = gql`
  query GetProfilesByLevelOfUse($levelOfUse: LevelOfUse!) {
    profilesByLevelOfUse(levelOfUse: $levelOfUse) {
      profileId
      name
      description
      levelOfUse
      application {
        applicationId
        name
      }
      roles {
        roleId
        name
        application {
          applicationId
          name
        }
      }
    }
  }
`;

/**
 * __useGetProfilesByLevelOfUseQuery__
 *
 * To run a query within a Vue component, call `useGetProfilesByLevelOfUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilesByLevelOfUseQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProfilesByLevelOfUseQuery({
 *   levelOfUse: // value for 'levelOfUse'
 * });
 */
export function useGetProfilesByLevelOfUseQuery(
  variables:
    | GetProfilesByLevelOfUseQueryVariables
    | VueCompositionApi.Ref<GetProfilesByLevelOfUseQueryVariables>
    | ReactiveFunction<GetProfilesByLevelOfUseQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetProfilesByLevelOfUseQuery,
        GetProfilesByLevelOfUseQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetProfilesByLevelOfUseQuery,
          GetProfilesByLevelOfUseQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetProfilesByLevelOfUseQuery,
          GetProfilesByLevelOfUseQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetProfilesByLevelOfUseQuery,
    GetProfilesByLevelOfUseQueryVariables
  >(GetProfilesByLevelOfUseDocument, variables, options);
}
export type GetProfilesByLevelOfUseQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetProfilesByLevelOfUseQuery,
    GetProfilesByLevelOfUseQueryVariables
  >;
export const ResetUserPasswordDocument = gql`
  mutation ResetUserPassword($input: ChangeUserPasswordInputType!) {
    changeUserPassword(input: $input)
  }
`;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetUserPasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResetUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetUserPasswordMutation,
        ResetUserPasswordMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetUserPasswordMutation,
          ResetUserPasswordMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >(ResetUserPasswordDocument, options);
}
export type ResetUserPasswordMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    ResetUserPasswordMutation,
    ResetUserPasswordMutationVariables
  >;
export const GetBasicOrganisationsDocument = gql`
  query getBasicOrganisations {
    organizationsForRoleAssignee {
      count
      items {
        ...BasicOrganizationParts
      }
    }
  }
  ${BasicOrganizationPartsFragmentDoc}
`;

/**
 * __useGetBasicOrganisationsQuery__
 *
 * To run a query within a Vue component, call `useGetBasicOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicOrganisationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBasicOrganisationsQuery();
 */
export function useGetBasicOrganisationsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetBasicOrganisationsQuery,
        GetBasicOrganisationsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetBasicOrganisationsQuery,
          GetBasicOrganisationsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetBasicOrganisationsQuery,
          GetBasicOrganisationsQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetBasicOrganisationsQuery,
    GetBasicOrganisationsQueryVariables
  >(GetBasicOrganisationsDocument, {}, options);
}
export type GetBasicOrganisationsQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetBasicOrganisationsQuery,
    GetBasicOrganisationsQueryVariables
  >;
export const UserProfilesExcelBatchDocument = gql`
  query userProfilesExcelBatch($organizationIds: [ID]) {
    userProfilesExcel(organizationIds: $organizationIds) {
      user {
        userId
        administrator
        organization {
          organizationId
          name
        }
        email
        firstname
        lastname
        mitID
        kombitID
        eID
        disabled
        lastLogin
        creationDate
      }
      organizationCVR
      userRoles {
        roleName
        roleAttribute
        organizationName
        organizationVat
        applicationName
        isOnBehalf
      }
    }
  }
`;

/**
 * __useUserProfilesExcelBatchQuery__
 *
 * To run a query within a Vue component, call `useUserProfilesExcelBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfilesExcelBatchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserProfilesExcelBatchQuery({
 *   organizationIds: // value for 'organizationIds'
 * });
 */
export function useUserProfilesExcelBatchQuery(
  variables:
    | UserProfilesExcelBatchQueryVariables
    | VueCompositionApi.Ref<UserProfilesExcelBatchQueryVariables>
    | ReactiveFunction<UserProfilesExcelBatchQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        UserProfilesExcelBatchQuery,
        UserProfilesExcelBatchQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          UserProfilesExcelBatchQuery,
          UserProfilesExcelBatchQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          UserProfilesExcelBatchQuery,
          UserProfilesExcelBatchQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    UserProfilesExcelBatchQuery,
    UserProfilesExcelBatchQueryVariables
  >(UserProfilesExcelBatchDocument, variables, options);
}
export type UserProfilesExcelBatchQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    UserProfilesExcelBatchQuery,
    UserProfilesExcelBatchQueryVariables
  >;
export const GetSelectableRolesDocument = gql`
  query GetSelectableRoles {
    roles {
      roleId
      attribute
      name
      application {
        applicationId
        name
      }
    }
  }
`;

/**
 * __useGetSelectableRolesQuery__
 *
 * To run a query within a Vue component, call `useGetSelectableRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectableRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSelectableRolesQuery();
 */
export function useGetSelectableRolesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSelectableRolesQuery,
        GetSelectableRolesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSelectableRolesQuery,
          GetSelectableRolesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSelectableRolesQuery,
          GetSelectableRolesQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetSelectableRolesQuery,
    GetSelectableRolesQueryVariables
  >(GetSelectableRolesDocument, {}, options);
}
export type GetSelectableRolesQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetSelectableRolesQuery,
    GetSelectableRolesQueryVariables
  >;
export const GetApplicationDocument = gql`
  query getApplication($applicationId: ID) {
    application(applicationId: $applicationId) {
      ...ApplicationDetailsParts
      roles {
        description
        roleId
        name
        users {
          count
        }
      }
      profiles {
        profileId
        name
        description
        levelOfUse
      }
    }
  }
  ${ApplicationDetailsPartsFragmentDoc}
`;

/**
 * __useGetApplicationQuery__
 *
 * To run a query within a Vue component, call `useGetApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetApplicationQuery({
 *   applicationId: // value for 'applicationId'
 * });
 */
export function useGetApplicationQuery(
  variables:
    | GetApplicationQueryVariables
    | VueCompositionApi.Ref<GetApplicationQueryVariables>
    | ReactiveFunction<GetApplicationQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetApplicationQuery,
        GetApplicationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetApplicationQuery,
          GetApplicationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetApplicationQuery,
          GetApplicationQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetApplicationQuery,
    GetApplicationQueryVariables
  >(GetApplicationDocument, variables, options);
}
export type GetApplicationQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetApplicationQuery,
    GetApplicationQueryVariables
  >;
export const GetApplicationsDocument = gql`
  query getApplications {
    applications {
      applicationId
      name
      roles {
        name
      }
    }
  }
`;

/**
 * __useGetApplicationsQuery__
 *
 * To run a query within a Vue component, call `useGetApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetApplicationsQuery();
 */
export function useGetApplicationsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetApplicationsQuery,
        GetApplicationsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetApplicationsQuery,
          GetApplicationsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetApplicationsQuery,
          GetApplicationsQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetApplicationsQuery,
    GetApplicationsQueryVariables
  >(GetApplicationsDocument, {}, options);
}
export type GetApplicationsQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetApplicationsQuery,
    GetApplicationsQueryVariables
  >;
export const GetBatchRoleAssignmentsDocument = gql`
  query GetBatchRoleAssignments {
    batchRoleAssignments {
      email
      roleName
      roleId
      orgCVR
      organizationId
      organizationName
    }
  }
`;

/**
 * __useGetBatchRoleAssignmentsQuery__
 *
 * To run a query within a Vue component, call `useGetBatchRoleAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchRoleAssignmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBatchRoleAssignmentsQuery();
 */
export function useGetBatchRoleAssignmentsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetBatchRoleAssignmentsQuery,
        GetBatchRoleAssignmentsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetBatchRoleAssignmentsQuery,
          GetBatchRoleAssignmentsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetBatchRoleAssignmentsQuery,
          GetBatchRoleAssignmentsQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetBatchRoleAssignmentsQuery,
    GetBatchRoleAssignmentsQueryVariables
  >(GetBatchRoleAssignmentsDocument, {}, options);
}
export type GetBatchRoleAssignmentsQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetBatchRoleAssignmentsQuery,
    GetBatchRoleAssignmentsQueryVariables
  >;
export const IsBatchRoleAssignmentRunningDocument = gql`
  query IsBatchRoleAssignmentRunning {
    isBatchRoleAssignmentRunning
  }
`;

/**
 * __useIsBatchRoleAssignmentRunningQuery__
 *
 * To run a query within a Vue component, call `useIsBatchRoleAssignmentRunningQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsBatchRoleAssignmentRunningQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIsBatchRoleAssignmentRunningQuery();
 */
export function useIsBatchRoleAssignmentRunningQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        IsBatchRoleAssignmentRunningQuery,
        IsBatchRoleAssignmentRunningQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          IsBatchRoleAssignmentRunningQuery,
          IsBatchRoleAssignmentRunningQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          IsBatchRoleAssignmentRunningQuery,
          IsBatchRoleAssignmentRunningQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    IsBatchRoleAssignmentRunningQuery,
    IsBatchRoleAssignmentRunningQueryVariables
  >(IsBatchRoleAssignmentRunningDocument, {}, options);
}
export type IsBatchRoleAssignmentRunningQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    IsBatchRoleAssignmentRunningQuery,
    IsBatchRoleAssignmentRunningQueryVariables
  >;
export const LastBatchRoleAssignmentSimulationDocument = gql`
  query LastBatchRoleAssignmentSimulation {
    lastBatchRoleAssignmentSimulation {
      settingId
      key
      value
    }
  }
`;

/**
 * __useLastBatchRoleAssignmentSimulationQuery__
 *
 * To run a query within a Vue component, call `useLastBatchRoleAssignmentSimulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastBatchRoleAssignmentSimulationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLastBatchRoleAssignmentSimulationQuery();
 */
export function useLastBatchRoleAssignmentSimulationQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        LastBatchRoleAssignmentSimulationQuery,
        LastBatchRoleAssignmentSimulationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          LastBatchRoleAssignmentSimulationQuery,
          LastBatchRoleAssignmentSimulationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          LastBatchRoleAssignmentSimulationQuery,
          LastBatchRoleAssignmentSimulationQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    LastBatchRoleAssignmentSimulationQuery,
    LastBatchRoleAssignmentSimulationQueryVariables
  >(LastBatchRoleAssignmentSimulationDocument, {}, options);
}
export type LastBatchRoleAssignmentSimulationQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    LastBatchRoleAssignmentSimulationQuery,
    LastBatchRoleAssignmentSimulationQueryVariables
  >;
export const LastBatchRoleAssignmentExecutionDocument = gql`
  query LastBatchRoleAssignmentExecution {
    lastBatchRoleAssignmentExecution {
      settingId
      key
      value
    }
  }
`;

/**
 * __useLastBatchRoleAssignmentExecutionQuery__
 *
 * To run a query within a Vue component, call `useLastBatchRoleAssignmentExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastBatchRoleAssignmentExecutionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLastBatchRoleAssignmentExecutionQuery();
 */
export function useLastBatchRoleAssignmentExecutionQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        LastBatchRoleAssignmentExecutionQuery,
        LastBatchRoleAssignmentExecutionQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          LastBatchRoleAssignmentExecutionQuery,
          LastBatchRoleAssignmentExecutionQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          LastBatchRoleAssignmentExecutionQuery,
          LastBatchRoleAssignmentExecutionQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    LastBatchRoleAssignmentExecutionQuery,
    LastBatchRoleAssignmentExecutionQueryVariables
  >(LastBatchRoleAssignmentExecutionDocument, {}, options);
}
export type LastBatchRoleAssignmentExecutionQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    LastBatchRoleAssignmentExecutionQuery,
    LastBatchRoleAssignmentExecutionQueryVariables
  >;
export const UploadBatchRoleAssignmentsCsvDocument = gql`
  mutation UploadBatchRoleAssignmentsCsv($input: UploadCsvInputType!) {
    uploadBatchRoleAssignmentsCsv(input: $input) {
      success
      errors
      validRoleAssignmentItems {
        email
        roleName
        roleId
        orgCVR
        organizationId
      }
    }
  }
`;

/**
 * __useUploadBatchRoleAssignmentsCsvMutation__
 *
 * To run a mutation, you first call `useUploadBatchRoleAssignmentsCsvMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadBatchRoleAssignmentsCsvMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadBatchRoleAssignmentsCsvMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUploadBatchRoleAssignmentsCsvMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UploadBatchRoleAssignmentsCsvMutation,
        UploadBatchRoleAssignmentsCsvMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UploadBatchRoleAssignmentsCsvMutation,
          UploadBatchRoleAssignmentsCsvMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    UploadBatchRoleAssignmentsCsvMutation,
    UploadBatchRoleAssignmentsCsvMutationVariables
  >(UploadBatchRoleAssignmentsCsvDocument, options);
}
export type UploadBatchRoleAssignmentsCsvMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UploadBatchRoleAssignmentsCsvMutation,
    UploadBatchRoleAssignmentsCsvMutationVariables
  >;
export const DoBatchRoleAssignmentsDocument = gql`
  mutation DoBatchRoleAssignments($input: BatchRoleAssignmentOption!) {
    doBatchRoleAssignments(input: $input) {
      isSimulation
      success
      errors
      totalAssignments
      totalUsersAssignment
      processedAt
      finishedAt
      assignedRoles {
        email
        roleName
        roleId
        orgCVR
        organizationId
      }
    }
  }
`;

/**
 * __useDoBatchRoleAssignmentsMutation__
 *
 * To run a mutation, you first call `useDoBatchRoleAssignmentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDoBatchRoleAssignmentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDoBatchRoleAssignmentsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDoBatchRoleAssignmentsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DoBatchRoleAssignmentsMutation,
        DoBatchRoleAssignmentsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DoBatchRoleAssignmentsMutation,
          DoBatchRoleAssignmentsMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    DoBatchRoleAssignmentsMutation,
    DoBatchRoleAssignmentsMutationVariables
  >(DoBatchRoleAssignmentsDocument, options);
}
export type DoBatchRoleAssignmentsMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DoBatchRoleAssignmentsMutation,
    DoBatchRoleAssignmentsMutationVariables
  >;
export const UserRolesAssignmentReportExcelDocument = gql`
  query userRolesAssignmentReportExcel($isSimulation: Boolean) {
    userRolesAssignmentReportExcel(isSimulation: $isSimulation) {
      fileName
      contentType
      base64Data
    }
  }
`;

/**
 * __useUserRolesAssignmentReportExcelQuery__
 *
 * To run a query within a Vue component, call `useUserRolesAssignmentReportExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRolesAssignmentReportExcelQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserRolesAssignmentReportExcelQuery({
 *   isSimulation: // value for 'isSimulation'
 * });
 */
export function useUserRolesAssignmentReportExcelQuery(
  variables:
    | UserRolesAssignmentReportExcelQueryVariables
    | VueCompositionApi.Ref<UserRolesAssignmentReportExcelQueryVariables>
    | ReactiveFunction<UserRolesAssignmentReportExcelQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        UserRolesAssignmentReportExcelQuery,
        UserRolesAssignmentReportExcelQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          UserRolesAssignmentReportExcelQuery,
          UserRolesAssignmentReportExcelQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          UserRolesAssignmentReportExcelQuery,
          UserRolesAssignmentReportExcelQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    UserRolesAssignmentReportExcelQuery,
    UserRolesAssignmentReportExcelQueryVariables
  >(UserRolesAssignmentReportExcelDocument, variables, options);
}
export type UserRolesAssignmentReportExcelQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    UserRolesAssignmentReportExcelQuery,
    UserRolesAssignmentReportExcelQueryVariables
  >;
export const OauthUsageHistoryDocument = gql`
  query oauthUsageHistory {
    oauthUsageHistory {
      connectionName
      clientId
      latestUsage
      isClientCredentialFlow
    }
  }
`;

/**
 * __useOauthUsageHistoryQuery__
 *
 * To run a query within a Vue component, call `useOauthUsageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOauthUsageHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOauthUsageHistoryQuery();
 */
export function useOauthUsageHistoryQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        OauthUsageHistoryQuery,
        OauthUsageHistoryQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          OauthUsageHistoryQuery,
          OauthUsageHistoryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          OauthUsageHistoryQuery,
          OauthUsageHistoryQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    OauthUsageHistoryQuery,
    OauthUsageHistoryQueryVariables
  >(OauthUsageHistoryDocument, {}, options);
}
export type OauthUsageHistoryQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    OauthUsageHistoryQuery,
    OauthUsageHistoryQueryVariables
  >;
export const GetLogDocument = gql`
  query GetLog($id: Int!) {
    log(id: $id) {
      ...LogParts
    }
  }
  ${LogPartsFragmentDoc}
`;

/**
 * __useGetLogQuery__
 *
 * To run a query within a Vue component, call `useGetLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLogQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetLogQuery(
  variables:
    | GetLogQueryVariables
    | VueCompositionApi.Ref<GetLogQueryVariables>
    | ReactiveFunction<GetLogQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetLogQuery, GetLogQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetLogQuery, GetLogQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetLogQuery, GetLogQueryVariables>
      > = {}
) {
  return VueApolloComposable.useQuery<GetLogQuery, GetLogQueryVariables>(
    GetLogDocument,
    variables,
    options
  );
}
export type GetLogQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<GetLogQuery, GetLogQueryVariables>;
export const GetLogsPaginationDocument = gql`
  query GetLogsPagination(
    $pageParams: PageParamsInputType!
    $filter: LogFilterInput
  ) {
    logsPagination(pageParams: $pageParams, filter: $filter) {
      items {
        ...LogParts
      }
      total
    }
  }
  ${LogPartsFragmentDoc}
`;

/**
 * __useGetLogsPaginationQuery__
 *
 * To run a query within a Vue component, call `useGetLogsPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogsPaginationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLogsPaginationQuery({
 *   pageParams: // value for 'pageParams'
 *   filter: // value for 'filter'
 * });
 */
export function useGetLogsPaginationQuery(
  variables:
    | GetLogsPaginationQueryVariables
    | VueCompositionApi.Ref<GetLogsPaginationQueryVariables>
    | ReactiveFunction<GetLogsPaginationQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetLogsPaginationQuery,
        GetLogsPaginationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetLogsPaginationQuery,
          GetLogsPaginationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetLogsPaginationQuery,
          GetLogsPaginationQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetLogsPaginationQuery,
    GetLogsPaginationQueryVariables
  >(GetLogsPaginationDocument, variables, options);
}
export type GetLogsPaginationQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetLogsPaginationQuery,
    GetLogsPaginationQueryVariables
  >;
export const GetLogYearRangeDocument = gql`
  query GetLogYearRange {
    logYearRange {
      fromYear
      toYear
    }
  }
`;

/**
 * __useGetLogYearRangeQuery__
 *
 * To run a query within a Vue component, call `useGetLogYearRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogYearRangeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLogYearRangeQuery();
 */
export function useGetLogYearRangeQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetLogYearRangeQuery,
        GetLogYearRangeQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetLogYearRangeQuery,
          GetLogYearRangeQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetLogYearRangeQuery,
          GetLogYearRangeQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetLogYearRangeQuery,
    GetLogYearRangeQueryVariables
  >(GetLogYearRangeDocument, {}, options);
}
export type GetLogYearRangeQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetLogYearRangeQuery,
    GetLogYearRangeQueryVariables
  >;
export const GetDistinctEventIdsDocument = gql`
  query GetDistinctEventIds {
    distinctEventIds {
      id
      description
    }
  }
`;

/**
 * __useGetDistinctEventIdsQuery__
 *
 * To run a query within a Vue component, call `useGetDistinctEventIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistinctEventIdsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDistinctEventIdsQuery();
 */
export function useGetDistinctEventIdsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetDistinctEventIdsQuery,
        GetDistinctEventIdsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetDistinctEventIdsQuery,
          GetDistinctEventIdsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetDistinctEventIdsQuery,
          GetDistinctEventIdsQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetDistinctEventIdsQuery,
    GetDistinctEventIdsQueryVariables
  >(GetDistinctEventIdsDocument, {}, options);
}
export type GetDistinctEventIdsQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetDistinctEventIdsQuery,
    GetDistinctEventIdsQueryVariables
  >;
export const GetUserMyProfileDocument = gql`
  query getUserMyProfile($id: ID) {
    getUserMyProfile(userId: $id) {
      ...UserParts
      roles {
        roleId
        organizationId
        applicationId
        roleName
        organizationName
        applicationName
      }
    }
  }
  ${UserPartsFragmentDoc}
`;

/**
 * __useGetUserMyProfileQuery__
 *
 * To run a query within a Vue component, call `useGetUserMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMyProfileQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserMyProfileQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetUserMyProfileQuery(
  variables:
    | GetUserMyProfileQueryVariables
    | VueCompositionApi.Ref<GetUserMyProfileQueryVariables>
    | ReactiveFunction<GetUserMyProfileQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetUserMyProfileQuery,
        GetUserMyProfileQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetUserMyProfileQuery,
          GetUserMyProfileQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetUserMyProfileQuery,
          GetUserMyProfileQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetUserMyProfileQuery,
    GetUserMyProfileQueryVariables
  >(GetUserMyProfileDocument, variables, options);
}
export type GetUserMyProfileQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetUserMyProfileQuery,
    GetUserMyProfileQueryVariables
  >;
export const GetOrganizationDocument = gql`
  query GetOrganization(
    $organizationId: ID
    $pageParams: PageParamsInputType!
  ) {
    organization(organizationId: $organizationId) {
      name
      organizationId
      vat
      notifiedOnChange
      notifiedOnUserChange
      notifiedOnRoleAssignmentChange
      users(pageParams: $pageParams) {
        total
        items {
          ...OrganizationUserParts
        }
      }
      oboUsers(pageParams: $pageParams) {
        total
        items {
          ...OrganizationUserParts
        }
      }
      assigneeRoles {
        roleId
        roleName
        isOnBehalf
        applicationId
        applicationName
        organizationId
        organizationName
      }
    }
  }
  ${OrganizationUserPartsFragmentDoc}
`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a Vue component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrganizationQuery({
 *   organizationId: // value for 'organizationId'
 *   pageParams: // value for 'pageParams'
 * });
 */
export function useGetOrganizationQuery(
  variables:
    | GetOrganizationQueryVariables
    | VueCompositionApi.Ref<GetOrganizationQueryVariables>
    | ReactiveFunction<GetOrganizationQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOrganizationQuery,
        GetOrganizationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOrganizationQuery,
          GetOrganizationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOrganizationQuery,
          GetOrganizationQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetOrganizationQuery,
    GetOrganizationQueryVariables
  >(GetOrganizationDocument, variables, options);
}
export type GetOrganizationQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetOrganizationQuery,
    GetOrganizationQueryVariables
  >;
export const GetOrganisationsDocument = gql`
  query getOrganisations {
    organizations {
      count
      items {
        ...BasicOrganizationParts
      }
    }
  }
  ${BasicOrganizationPartsFragmentDoc}
`;

/**
 * __useGetOrganisationsQuery__
 *
 * To run a query within a Vue component, call `useGetOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOrganisationsQuery();
 */
export function useGetOrganisationsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOrganisationsQuery,
        GetOrganisationsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOrganisationsQuery,
          GetOrganisationsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOrganisationsQuery,
          GetOrganisationsQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetOrganisationsQuery,
    GetOrganisationsQueryVariables
  >(GetOrganisationsDocument, {}, options);
}
export type GetOrganisationsQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetOrganisationsQuery,
    GetOrganisationsQueryVariables
  >;
export const GetProfileApplicationDocument = gql`
  query getProfileApplication($id: ID) {
    profile(profileId: $id) {
      ...ProfileParts
      application {
        applicationId
        name
        roles {
          roleId
          name
        }
      }
      roles {
        roleId
        name
      }
    }
  }
  ${ProfilePartsFragmentDoc}
`;

/**
 * __useGetProfileApplicationQuery__
 *
 * To run a query within a Vue component, call `useGetProfileApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileApplicationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProfileApplicationQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetProfileApplicationQuery(
  variables:
    | GetProfileApplicationQueryVariables
    | VueCompositionApi.Ref<GetProfileApplicationQueryVariables>
    | ReactiveFunction<GetProfileApplicationQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetProfileApplicationQuery,
        GetProfileApplicationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetProfileApplicationQuery,
          GetProfileApplicationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetProfileApplicationQuery,
          GetProfileApplicationQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetProfileApplicationQuery,
    GetProfileApplicationQueryVariables
  >(GetProfileApplicationDocument, variables, options);
}
export type GetProfileApplicationQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetProfileApplicationQuery,
    GetProfileApplicationQueryVariables
  >;
export const AddProfileRoleDocument = gql`
  mutation addProfileRole($input: AddProfileRoleInputType!) {
    addProfileRole(input: $input)
  }
`;

/**
 * __useAddProfileRoleMutation__
 *
 * To run a mutation, you first call `useAddProfileRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddProfileRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddProfileRoleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddProfileRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddProfileRoleMutation,
        AddProfileRoleMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddProfileRoleMutation,
          AddProfileRoleMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    AddProfileRoleMutation,
    AddProfileRoleMutationVariables
  >(AddProfileRoleDocument, options);
}
export type AddProfileRoleMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddProfileRoleMutation,
    AddProfileRoleMutationVariables
  >;
export const CreateProfileDocument = gql`
  mutation createProfile($input: CreateProfileInputType!) {
    createProfile(input: $input) {
      ...ProfileParts
    }
  }
  ${ProfilePartsFragmentDoc}
`;

/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateProfileMutation,
        CreateProfileMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateProfileMutation,
          CreateProfileMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    CreateProfileMutation,
    CreateProfileMutationVariables
  >(CreateProfileDocument, options);
}
export type CreateProfileMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateProfileMutation,
    CreateProfileMutationVariables
  >;
export const DeleteProfileDocument = gql`
  mutation deleteProfile($id: ID!) {
    deleteProfile(profileId: $id)
  }
`;

/**
 * __useDeleteProfileMutation__
 *
 * To run a mutation, you first call `useDeleteProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProfileMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteProfileMutation,
        DeleteProfileMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteProfileMutation,
          DeleteProfileMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    DeleteProfileMutation,
    DeleteProfileMutationVariables
  >(DeleteProfileDocument, options);
}
export type DeleteProfileMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DeleteProfileMutation,
    DeleteProfileMutationVariables
  >;
export const RemoveProfileRoleDocument = gql`
  mutation removeProfileRole($input: RemoveProfileRoleInputType!) {
    removeProfileRole(input: $input)
  }
`;

/**
 * __useRemoveProfileRoleMutation__
 *
 * To run a mutation, you first call `useRemoveProfileRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProfileRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveProfileRoleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProfileRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveProfileRoleMutation,
        RemoveProfileRoleMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveProfileRoleMutation,
          RemoveProfileRoleMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    RemoveProfileRoleMutation,
    RemoveProfileRoleMutationVariables
  >(RemoveProfileRoleDocument, options);
}
export type RemoveProfileRoleMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveProfileRoleMutation,
    RemoveProfileRoleMutationVariables
  >;
export const UpdateProfileDocument = gql`
  mutation updateProfile($input: UpdateProfileInputType!) {
    updateProfile(input: $input) {
      ...ProfileParts
    }
  }
  ${ProfilePartsFragmentDoc}
`;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateProfileMutation,
        UpdateProfileMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateProfileMutation,
          UpdateProfileMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    UpdateProfileMutation,
    UpdateProfileMutationVariables
  >(UpdateProfileDocument, options);
}
export type UpdateProfileMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateProfileMutation,
    UpdateProfileMutationVariables
  >;
export const GetRoleDocument = gql`
  query getRole($id: ID) {
    role(roleId: $id) {
      ...RoleParts
      application {
        applicationId
        name
      }
      assignees {
        organizationId
        name
      }
      users {
        items {
          organization {
            name
          }
          email
          userId
          firstname
          lastname
        }
      }
    }
  }
  ${RolePartsFragmentDoc}
`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a Vue component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRoleQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetRoleQuery(
  variables:
    | GetRoleQueryVariables
    | VueCompositionApi.Ref<GetRoleQueryVariables>
    | ReactiveFunction<GetRoleQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetRoleQuery, GetRoleQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetRoleQuery, GetRoleQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetRoleQuery, GetRoleQueryVariables>
      > = {}
) {
  return VueApolloComposable.useQuery<GetRoleQuery, GetRoleQueryVariables>(
    GetRoleDocument,
    variables,
    options
  );
}
export type GetRoleQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<GetRoleQuery, GetRoleQueryVariables>;
export const AddRoleAssigneeDocument = gql`
  mutation AddRoleAssignee($input: AddRoleAssigneeInputType!) {
    addRoleAssignee(input: $input)
  }
`;

/**
 * __useAddRoleAssigneeMutation__
 *
 * To run a mutation, you first call `useAddRoleAssigneeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleAssigneeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddRoleAssigneeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddRoleAssigneeMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddRoleAssigneeMutation,
        AddRoleAssigneeMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddRoleAssigneeMutation,
          AddRoleAssigneeMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    AddRoleAssigneeMutation,
    AddRoleAssigneeMutationVariables
  >(AddRoleAssigneeDocument, options);
}
export type AddRoleAssigneeMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddRoleAssigneeMutation,
    AddRoleAssigneeMutationVariables
  >;
export const CreateRoleDocument = gql`
  mutation CreateRole($input: CreateRoleInputType!) {
    createRole(input: $input) {
      ...RoleParts
    }
  }
  ${RolePartsFragmentDoc}
`;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRoleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateRoleMutation,
        CreateRoleMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateRoleMutation,
          CreateRoleMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    CreateRoleMutation,
    CreateRoleMutationVariables
  >(CreateRoleDocument, options);
}
export type CreateRoleMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateRoleMutation,
    CreateRoleMutationVariables
  >;
export const DeleteRoleDocument = gql`
  mutation DeleteRole($id: ID!) {
    deleteRole(roleId: $id)
  }
`;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRoleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteRoleMutation,
        DeleteRoleMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteRoleMutation,
          DeleteRoleMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    DeleteRoleMutation,
    DeleteRoleMutationVariables
  >(DeleteRoleDocument, options);
}
export type DeleteRoleMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DeleteRoleMutation,
    DeleteRoleMutationVariables
  >;
export const RemoveRoleAssigneeDocument = gql`
  mutation RemoveRoleAssignee($roleId: ID!, $organizationId: ID!) {
    removeRoleAssignee(roleId: $roleId, organizationId: $organizationId)
  }
`;

/**
 * __useRemoveRoleAssigneeMutation__
 *
 * To run a mutation, you first call `useRemoveRoleAssigneeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleAssigneeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveRoleAssigneeMutation({
 *   variables: {
 *     roleId: // value for 'roleId'
 *     organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRemoveRoleAssigneeMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveRoleAssigneeMutation,
        RemoveRoleAssigneeMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveRoleAssigneeMutation,
          RemoveRoleAssigneeMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    RemoveRoleAssigneeMutation,
    RemoveRoleAssigneeMutationVariables
  >(RemoveRoleAssigneeDocument, options);
}
export type RemoveRoleAssigneeMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveRoleAssigneeMutation,
    RemoveRoleAssigneeMutationVariables
  >;
export const UpdateRoleDocument = gql`
  mutation UpdateRole($input: UpdateRoleInputType!) {
    updateRole(input: $input) {
      ...RoleParts
    }
  }
  ${RolePartsFragmentDoc}
`;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRoleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateRoleMutation,
        UpdateRoleMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateRoleMutation,
          UpdateRoleMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    UpdateRoleMutation,
    UpdateRoleMutationVariables
  >(UpdateRoleDocument, options);
}
export type UpdateRoleMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateRoleMutation,
    UpdateRoleMutationVariables
  >;
export const GetNotificationEmailsDocument = gql`
  query GetNotificationEmails {
    notificationEmails {
      count
      items {
        ...NotificationEmailParts
      }
    }
  }
  ${NotificationEmailPartsFragmentDoc}
`;

/**
 * __useGetNotificationEmailsQuery__
 *
 * To run a query within a Vue component, call `useGetNotificationEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationEmailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNotificationEmailsQuery();
 */
export function useGetNotificationEmailsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetNotificationEmailsQuery,
        GetNotificationEmailsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetNotificationEmailsQuery,
          GetNotificationEmailsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetNotificationEmailsQuery,
          GetNotificationEmailsQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetNotificationEmailsQuery,
    GetNotificationEmailsQueryVariables
  >(GetNotificationEmailsDocument, {}, options);
}
export type GetNotificationEmailsQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetNotificationEmailsQuery,
    GetNotificationEmailsQueryVariables
  >;
export const AddNotificationEmailDocument = gql`
  mutation AddNotificationEmail($input: AddNotificationEmailInputType!) {
    addNotificationEmail(input: $input) {
      ...NotificationEmailParts
    }
  }
  ${NotificationEmailPartsFragmentDoc}
`;

/**
 * __useAddNotificationEmailMutation__
 *
 * To run a mutation, you first call `useAddNotificationEmailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationEmailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNotificationEmailMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddNotificationEmailMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddNotificationEmailMutation,
        AddNotificationEmailMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddNotificationEmailMutation,
          AddNotificationEmailMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    AddNotificationEmailMutation,
    AddNotificationEmailMutationVariables
  >(AddNotificationEmailDocument, options);
}
export type AddNotificationEmailMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddNotificationEmailMutation,
    AddNotificationEmailMutationVariables
  >;
export const DeleteNotificationEmailDocument = gql`
  mutation DeleteNotificationEmail($emailId: ID!) {
    deleteNotificationEmail(emailId: $emailId)
  }
`;

/**
 * __useDeleteNotificationEmailMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationEmailMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationEmailMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteNotificationEmailMutation({
 *   variables: {
 *     emailId: // value for 'emailId'
 *   },
 * });
 */
export function useDeleteNotificationEmailMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteNotificationEmailMutation,
        DeleteNotificationEmailMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteNotificationEmailMutation,
          DeleteNotificationEmailMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    DeleteNotificationEmailMutation,
    DeleteNotificationEmailMutationVariables
  >(DeleteNotificationEmailDocument, options);
}
export type DeleteNotificationEmailMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DeleteNotificationEmailMutation,
    DeleteNotificationEmailMutationVariables
  >;
export const GetSettingByKeyDocument = gql`
  query GetSettingByKey($key: String!) {
    setting(key: $key) {
      ...SettingParts
    }
  }
  ${SettingPartsFragmentDoc}
`;

/**
 * __useGetSettingByKeyQuery__
 *
 * To run a query within a Vue component, call `useGetSettingByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingByKeyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSettingByKeyQuery({
 *   key: // value for 'key'
 * });
 */
export function useGetSettingByKeyQuery(
  variables:
    | GetSettingByKeyQueryVariables
    | VueCompositionApi.Ref<GetSettingByKeyQueryVariables>
    | ReactiveFunction<GetSettingByKeyQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSettingByKeyQuery,
        GetSettingByKeyQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSettingByKeyQuery,
          GetSettingByKeyQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSettingByKeyQuery,
          GetSettingByKeyQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetSettingByKeyQuery,
    GetSettingByKeyQueryVariables
  >(GetSettingByKeyDocument, variables, options);
}
export type GetSettingByKeyQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetSettingByKeyQuery,
    GetSettingByKeyQueryVariables
  >;
export const UpdateSettingDocument = gql`
  mutation UpdateSetting($input: UpdateSettingInputType!) {
    updateSetting(input: $input) {
      ...SettingParts
    }
  }
  ${SettingPartsFragmentDoc}
`;

/**
 * __useUpdateSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateSettingMutation,
        UpdateSettingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateSettingMutation,
          UpdateSettingMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    UpdateSettingMutation,
    UpdateSettingMutationVariables
  >(UpdateSettingDocument, options);
}
export type UpdateSettingMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateSettingMutation,
    UpdateSettingMutationVariables
  >;
export const GetUserDocument = gql`
  query getUser($id: ID) {
    user(userId: $id) {
      ...UserParts
      roles {
        roleId
        organizationId
        applicationId
        roleName
        organizationName
        applicationName
      }
      authenticatorRegistration {
        enrollmentStatus
      }
    }
  }
  ${UserPartsFragmentDoc}
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a Vue component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetUserQuery(
  variables:
    | GetUserQueryVariables
    | VueCompositionApi.Ref<GetUserQueryVariables>
    | ReactiveFunction<GetUserQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetUserQuery, GetUserQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserQuery, GetUserQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserQuery, GetUserQueryVariables>
      > = {}
) {
  return VueApolloComposable.useQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    variables,
    options
  );
}
export type GetUserQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<GetUserQuery, GetUserQueryVariables>;
export const GetOboUserDocument = gql`
  query getOboUser($id: ID) {
    user(userId: $id) {
      ...OboUserParts
      roles {
        roleId
        organizationId
        applicationId
        roleName
        organizationName
        applicationName
      }
    }
  }
  ${OboUserPartsFragmentDoc}
`;

/**
 * __useGetOboUserQuery__
 *
 * To run a query within a Vue component, call `useGetOboUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOboUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOboUserQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetOboUserQuery(
  variables:
    | GetOboUserQueryVariables
    | VueCompositionApi.Ref<GetOboUserQueryVariables>
    | ReactiveFunction<GetOboUserQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOboUserQuery,
        GetOboUserQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOboUserQuery,
          GetOboUserQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOboUserQuery,
          GetOboUserQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetOboUserQuery,
    GetOboUserQueryVariables
  >(GetOboUserDocument, variables, options);
}
export type GetOboUserQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<GetOboUserQuery, GetOboUserQueryVariables>;
export const GetRolesForUserDocument = gql`
  query getRolesForUser($id: ID) {
    rolesForUser(userId: $id) {
      ...RoleAssigneeParts
    }
  }
  ${RoleAssigneePartsFragmentDoc}
`;

/**
 * __useGetRolesForUserQuery__
 *
 * To run a query within a Vue component, call `useGetRolesForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesForUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRolesForUserQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetRolesForUserQuery(
  variables:
    | GetRolesForUserQueryVariables
    | VueCompositionApi.Ref<GetRolesForUserQueryVariables>
    | ReactiveFunction<GetRolesForUserQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetRolesForUserQuery,
        GetRolesForUserQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetRolesForUserQuery,
          GetRolesForUserQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetRolesForUserQuery,
          GetRolesForUserQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetRolesForUserQuery,
    GetRolesForUserQueryVariables
  >(GetRolesForUserDocument, variables, options);
}
export type GetRolesForUserQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetRolesForUserQuery,
    GetRolesForUserQueryVariables
  >;
export const AddUserRoleDocument = gql`
  mutation AddUserRole($input: AddUserRoleInputType!) {
    addUserRole(input: $input)
  }
`;

/**
 * __useAddUserRoleMutation__
 *
 * To run a mutation, you first call `useAddUserRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserRoleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddUserRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddUserRoleMutation,
        AddUserRoleMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddUserRoleMutation,
          AddUserRoleMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    AddUserRoleMutation,
    AddUserRoleMutationVariables
  >(AddUserRoleDocument, options);
}
export type AddUserRoleMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddUserRoleMutation,
    AddUserRoleMutationVariables
  >;
export const CreateUserDocument = gql`
  mutation CreateUser($input: CreateUserInputType!) {
    createUser(input: $input) {
      ...UserParts
      roles {
        roleId
        organizationId
        applicationId
        roleName
        organizationName
        applicationName
      }
    }
  }
  ${UserPartsFragmentDoc}
`;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateUserMutation,
        CreateUserMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateUserMutation,
          CreateUserMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    CreateUserMutation,
    CreateUserMutationVariables
  >(CreateUserDocument, options);
}
export type CreateUserMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateUserMutation,
    CreateUserMutationVariables
  >;
export const DeleteUserDocument = gql`
  mutation deleteUser($userId: ID!) {
    deleteUser(userId: $userId)
  }
`;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteUserMutation,
        DeleteUserMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteUserMutation,
          DeleteUserMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    DeleteUserMutation,
    DeleteUserMutationVariables
  >(DeleteUserDocument, options);
}
export type DeleteUserMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    DeleteUserMutation,
    DeleteUserMutationVariables
  >;
export const MigrateUserToNonEidOrganizationDocument = gql`
  mutation migrateUserToNonEidOrganization($userId: ID!) {
    migrateUserToNonEidOrganization(userId: $userId) {
      userId
    }
  }
`;

/**
 * __useMigrateUserToNonEidOrganizationMutation__
 *
 * To run a mutation, you first call `useMigrateUserToNonEidOrganizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMigrateUserToNonEidOrganizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMigrateUserToNonEidOrganizationMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useMigrateUserToNonEidOrganizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        MigrateUserToNonEidOrganizationMutation,
        MigrateUserToNonEidOrganizationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          MigrateUserToNonEidOrganizationMutation,
          MigrateUserToNonEidOrganizationMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    MigrateUserToNonEidOrganizationMutation,
    MigrateUserToNonEidOrganizationMutationVariables
  >(MigrateUserToNonEidOrganizationDocument, options);
}
export type MigrateUserToNonEidOrganizationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    MigrateUserToNonEidOrganizationMutation,
    MigrateUserToNonEidOrganizationMutationVariables
  >;
export const RemoveUserRoleDocument = gql`
  mutation RemoveUserRole($input: RemoveUserRoleInputType!) {
    removeUserRole(input: $input)
  }
`;

/**
 * __useRemoveUserRoleMutation__
 *
 * To run a mutation, you first call `useRemoveUserRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveUserRoleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveUserRoleMutation,
        RemoveUserRoleMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveUserRoleMutation,
          RemoveUserRoleMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    RemoveUserRoleMutation,
    RemoveUserRoleMutationVariables
  >(RemoveUserRoleDocument, options);
}
export type RemoveUserRoleMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemoveUserRoleMutation,
    RemoveUserRoleMutationVariables
  >;
export const ResetUserAuthenticatorRegistrationDocument = gql`
  mutation resetUserAuthenticatorRegistration($userId: ID!) {
    resetUserAuthenticatorRegistration(userId: $userId)
  }
`;

/**
 * __useResetUserAuthenticatorRegistrationMutation__
 *
 * To run a mutation, you first call `useResetUserAuthenticatorRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetUserAuthenticatorRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetUserAuthenticatorRegistrationMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useResetUserAuthenticatorRegistrationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetUserAuthenticatorRegistrationMutation,
        ResetUserAuthenticatorRegistrationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetUserAuthenticatorRegistrationMutation,
          ResetUserAuthenticatorRegistrationMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    ResetUserAuthenticatorRegistrationMutation,
    ResetUserAuthenticatorRegistrationMutationVariables
  >(ResetUserAuthenticatorRegistrationDocument, options);
}
export type ResetUserAuthenticatorRegistrationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    ResetUserAuthenticatorRegistrationMutation,
    ResetUserAuthenticatorRegistrationMutationVariables
  >;
export const UpdateUserDocument = gql`
  mutation UpdateUser($input: UpdateUserInputType!) {
    updateUser(input: $input) {
      ...UserParts
      roles {
        roleId
        organizationId
        applicationId
        roleName
        organizationName
        applicationName
      }
    }
  }
  ${UserPartsFragmentDoc}
`;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateUserMutation,
        UpdateUserMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateUserMutation,
          UpdateUserMutationVariables
        >
      >
) {
  return VueApolloComposable.useMutation<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >;
export const GetUsersPaginationDocument = gql`
  query GetUsersPagination($pageParams: PageParamsInputType!) {
    usersPagination(pageParams: $pageParams) {
      items {
        userId
        firstname
        lastname
        email
        mitID
        kombitID
        eID
        administrator
        disabled
        lastLogin
        creationDate
        organization {
          organizationId
          name
        }
      }
      total
    }
  }
`;

/**
 * __useGetUsersPaginationQuery__
 *
 * To run a query within a Vue component, call `useGetUsersPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersPaginationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUsersPaginationQuery({
 *   pageParams: // value for 'pageParams'
 * });
 */
export function useGetUsersPaginationQuery(
  variables:
    | GetUsersPaginationQueryVariables
    | VueCompositionApi.Ref<GetUsersPaginationQueryVariables>
    | ReactiveFunction<GetUsersPaginationQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetUsersPaginationQuery,
        GetUsersPaginationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetUsersPaginationQuery,
          GetUsersPaginationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetUsersPaginationQuery,
          GetUsersPaginationQueryVariables
        >
      > = {}
) {
  return VueApolloComposable.useQuery<
    GetUsersPaginationQuery,
    GetUsersPaginationQueryVariables
  >(GetUsersPaginationDocument, variables, options);
}
export type GetUsersPaginationQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetUsersPaginationQuery,
    GetUsersPaginationQueryVariables
  >;
